export function VIFRulesMulDiv(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.ValueTextBlack_line = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#000000').ss(2, 0, 1).p('AifAAIE/AA');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#FFFFFF').ss(2, 0, 1).p('AihAAIFDAA');
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.1, -1, 34.3, 2);

  (lib.ValueText_glow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        [
          'rgba(255,255,255,0.502)',
          'rgba(255,255,255,0.8)',
          'rgba(255,255,255,0)',
        ],
        [0, 0, 1],
        0,
        0,
        0,
        0,
        0,
        20.8,
      )
      .s()
      .p(
        'AiRCSQg9g8ABhWQgBhVA9g8QA8g9BVAAQBVAAA9A9QA9A8gBBVQABBWg9A8Qg9A9hVAAQhVAAg8g9g',
      );
    this.shape.setTransform(0.0184, -0.0236, 1.4528, 1.4492);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueText_glow,
    new cjs.Rectangle(-30, -30, 60, 60),
    null,
  );

  (lib.comsuntexsymbolsValueText = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.smallText = new cjs.Text('1', "bold 16px 'Tahoma'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 19;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(17.65, 2);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueText,
    new cjs.Rectangle(-13, 0, 61.3, 25.8),
    null,
  );

  (lib.PostivieFeedback_bg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(153,0,153,0.2)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape.setTransform(-0.0024, -0.0204);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,51,51,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_1.setTransform(-0.0024, -0.0204);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_2.setTransform(-0.0024, -0.0204);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_3.setTransform(-0.0024, -0.0204);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_4.setTransform(-0.0024, -0.0204);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(0,102,204,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_5.setTransform(-0.0024, -0.0204);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('rgba(102,0,204,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_6.setTransform(-0.0024, -0.0204);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('AtCkrIaFCWIhGCMI2LE1g');
    this.shape_7.setTransform(6.4, 0.55);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,51,51,0.298)')
      .s()
      .p('Av7gaICtkfIJgIDIIWn1ILUG4IlFCKIlWmIIo9Grg');
    this.shape_8.setTransform(0.075, -0.075);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p('Av7gaICtkfIJ+EoIKsjeIIgF8IlFCKIlWmIIo9Grg');
    this.shape_9.setTransform(0.075, -0.075);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p('AvdjRIOXAxIGJEBIFWmJIFFCLIo+FyIqsjeIpgExg');
    this.shape_10.setTransform(3.075, 1.6);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(102,51,204,0.298)')
      .s()
      .p('AtvCbICgjHIWBjIIC+Hpg');
    this.shape_11.setTransform(-1.5, -1.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p('ADvjJIoWH1IrUm4IFFiKIFWGIII9mrIMfFUIitEfg');
    this.shape_12.setTransform(0.025, -0.125);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('rgba(0,51,204,0.298)')
      .s()
      .p('Av7ghIKhjZIBsG9IIWn1ILUG4IlFCKIlMiZIpHC8g');
    this.shape_13.setTransform(0.075, 0.625);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('Av7iFIFFiKIFgEQIIzkzIMfFUIqhCxIhsmVIoWH1g');
    this.shape_14.setTransform(0.025, 0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 13)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102, -38.8, 204.1, 77.6);

  (lib.PostitiveFeedback_text = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape.setTransform(-3.425, 2.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_1.setTransform(-7.025, 0.425);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AhOBuQgMgTAAgFQAAAAAAAAQAAgBABAAQAAAAAAAAQAAgBABAAIAYgEQAQgFAAgLQAAgIgJgKIgRgTQgIgNgBgOQABgZAagTQAYgQAcAAQACAAAKATQAMATAAADQAAACgEADIgJgBQgJAAgIAEQgIAFAAAJQAAAGAJAKQANAOACAFQAKANgBAQQABAIgEALQgEALgGAFQgMALgSAIQgSAIgQAAQgDAAgNgTgAI4BnQgagZAAgpQAAgoAXgaQAYgaAoAAQAjAAAXAYQAXAZAAAhQABASgMACIglAEIg9AFQACAMANAGQAKAFANAAQAQAAAPgJIANgIQAFACAIAQQAJAQAAAEQAAACgDACQgVAXguAAQgpAAgagYgAJdgBQgHAIAAALQAAAFAEAAQANAAAcgEQAGgBAAgCQAAgLgIgHQgIgIgKAAQgMAAgGAJgAj1BnQgagZAAgpQAAgoAYgaQAYgaAoAAQAiAAAXAYQAYAZAAAhQAAASgLACIglAEIg9AFQABAMANAGQALAFAMAAQAQAAAQgJIANgIQAEACAIAQQAJAQAAAEQAAACgDACQgUAXguAAQgqAAgagYgAjQgBQgHAIABALQgBAFAFAAQANAAAcgEQAFgBAAgCQABgLgJgHQgHgIgLAAQgLAAgHAJgALnB1QgJgKAAgPQAAgOAJgKQAKgJAOAAQAPAAAJAJQAKAKgBAOQABAPgKAKQgJAKgPAAQgOAAgKgKgAA9BlQgZgYAAgnQAAgoAYgZQAYgaAoAAQAoAAAZAZQAZAZgBAnQABAogZAZQgZAZgoAAQgmAAgZgZgABmAMQgIAKAAAOQAAAOAIAKQAJALAOAAQANAAAKgLQAIgKAAgOQAAgOgIgLQgKgKgNAAQgOAAgJALgApuB6QgGgBgCgHQgGgZgDgCQgCgBgtAAQgeAAgBACQgEACgDAQQgEAPgFABQgFACgiAAQgbAAAAgFQAAgFAnhsIAvh/QACgHADAAIAOABIAPABIAPAAIANgBQAEAAADAGQAIASApBrQAqBtAAAFQAAADgEABQgFACgbAAQgaAAgHgCgAqxgIQgKAbAAAEQAAAEALAAIASAAQALAAABgCIAAgDQAAgGgIgZQgHgZgEgHQgEAHgIAagAHKB6QgGgBABgHIAAgYIABgZIgBgrQgBgVgTAAQgIAAgIAHQgJAGAAAJIgBArIABAZIAAAZQAAAGgFAAIg2AAQgEAAAAgHIAAgZIABgZIAAgTIgBgUQAAgZgTAAQgIAAgJAGQgJAGAAAHIAAAwIAAAwQAAAEgBABIgGACIgZAAIgZgBIgFgBQgBgBAAgEIABgqIAAgqQAAgdgFgjIAAgDQAAgDADgCQADgBALgBIAPgCIAPgDQAIgDAFAAQAEAAAAAMQAAANACAAIADgDQAQgMAKgFQANgGAQAAQAQAAAMAHQAPAIAEAPQAKgNAPgJQARgIAQAAQAWAAAQAKQAQANAAAWIAAAbIgBAcIABAiIAAAhQAAAGgGABIgaAAQgVAAgFgBgAl7B6IgGgDQgKgKgVgnQgWAogIAJQgFAEgSAAQgNAAgFgBQgIgCgVgkQgRgdgIgSQgEgLAAgaQAAggABgIQACgEAFAAIAYAAIAYABQAEAAABAGIgBAPIgBAQQAAAUACAKQAAAEAKAQQAIAQADAAQACAAAJgQQAHgNACgGQACgHAAgYIgBgQIgBgPQAAgGAEAAIAUAAIAMAAIATAAQAEABAAAFIAAAUIgBATQAAASABAFQACAGAGANQAIAQAEAAQACAAAJgQQAIgPABgFIAAg9QABgGADAAIAYgBIAZAAQAEAAACAEQABAIABAgQAAAbgFAKQgFAMgRAeQgTAggHAHQgFAFgTAAQgPAAgEgBgALvAlQgRg4AAgIIABgVIAAgVIAAgYIgBgYQAAgGADAAIAPAAIAPABIAPgBIAPAAQADAAAAAqQAAAggFAcIgPA5QgBAGgMAAQgOAAgCgFg',
      );
    this.shape_2.setTransform(-6.75, -0.625);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AJaCXIgQgBQgFgBAAgFIABiIQgBgogGgcIAAgDQAAAAAAgBQAAAAAAgBQABAAAAgBQABAAAAAAQAHgDATgDQATgDAIAAQAIAAAAAJQABAJABAAIAAAAIAAAAIAQgJQARgKANAAQAnAAAWAZQAWAYABAmQgBAmgWAZQgWAZgmAAQgNAAgQgGIgOgHQgCAAAAAFIABAbIABAbQAAAGgGAAgAKKgNQgIAKAAAOQABAPAHAKQAJAKAOAAQAfAAAAgjQAAgNgJgLQgJgLgNAAQgPAAgIALgAjvCXIgPgBQgFgBgBgFIABiIQAAgogGgcIgBgDQAAAAABgBQAAAAAAgBQAAAAABgBQAAAAABAAQAGgDAUgDQASgDAJAAQAHAAABAJQABAJABAAIAAAAIAAAAIAPgJQARgKAOAAQAmAAAXAZQAWAYAAAmQAAAmgWAZQgXAZglAAQgOAAgPgGIgPgHQgBAAAAAFIAAAbIABAbQAAAGgGAAgAi+gNQgIAKAAAOQAAAPAIAKQAIAKAOAAQAgAAAAgjQAAgNgJgLQgJgLgOAAQgOAAgIALgAmrBMQgagYAAgqQgBgnAYgaQAYgbAoAAQAiAAAYAZQAXAYAAAhQAAASgLADIglADIg9AGQACALANAGQAKAFANAAQAQAAAQgIIAMgJQAFACAIAQQAJAQAAAFQAAAAAAABQAAAAgBABQAAAAgBABQAAAAgBABQgVAXguAAQgpAAgagZgAmGgcQgHAJAAAMQAAAEAEAAQANAAAcgEQAGAAAAgCQAAgLgIgJQgIgIgKAAQgMAAgGAJgApgBMQgagYAAgqQAAgnAYgaQAYgbAoAAQAiAAAYAZQAXAYAAAhQAAASgMADIgkADIg+AGQACALANAGQAKAFANAAQAQAAAQgIIANgJQAEACAJAQQAIAQABAFQAAABgEADQgUAXguAAQgqAAgagZgAo7gcQgGAJAAAMQgBAEAFAAQANAAAcgEQAFAAAAgCQAAgLgHgJQgIgIgLAAQgLAAgHAJgAMmBaQgKgJAAgPQAAgPAKgJQAIgKAPAAQAPAAAJAKQAKAJAAAPQAAAPgKAJQgJAKgPAAQgPAAgIgKgACSA8IABgjIABgiQAAgHgIAAIgDAAIgDAAQgGAAAAgFIAAgJIABgIIgBgLIAAgMQAAgDAMgBQAGAAAAgDIABgVIgBgWQAAgUAEAAIANACIAPADIAbADQAEAAAAADIgBAVIgCAWQAAAIAGAAIATAAIASgBQABAAABAAQABABAAAAQABAAAAABQAAAAAAABIgBAMIgBAMIAAAMIAAANQABADgGAAIgMAAIgLAAIgNAAQgDAAAAAIIAAALIAAAMQAAAPADAGQAGAHAOAAIAMgCIALgCQAEAAAAAEIgBAQIgCAQIgBAGIgFAEQgXANgbAAQg0AAAAgngAHmBgQgDAAgBgEIgBgKQgBgIgBAAQABAAgUAMQgTAMgRAAQgvAAgIgrQgEgTAAgkQAAgoAGgXQACgIAFAAIAZABIAZAAQAGAAgBAEIAAAEQgEAYABAZQgBAdACALQAEAUATAAQAIAAAJgHQAJgHAAgHIABhYIABgGQAAgCAGAAIAaAAIAaAAQAFAAABADIABAEIgCAnIgBAmIABAmIABAmQAAAFgFABQgHACgVAAQgTAAgIgCgArHBgIgGgCIgEgFIgagvQgUgmgFgEQgSAHgBADIABAoIACAoQAAAFgFABQgJABgYAAQgXAAgHgBQgFgBgBgFIACg5IADg4IgDg+IgBg9QAAgBAAgBQAAAAABgBQAAAAABgBQABAAABAAIAQABIAQAAIARAAIAQgBQABAAABAAQAAABABAAQAAAAAAABQAAAAAAABIgBAoIgBAnQAAAPAIAAQAVAAAMgLQAIgJAJgWIATgyQACgFAFAAIAOABIAOAAIAOAAIAPgBQADAAAAAFQAAAFgHAXQgWBCgcARQgGADAAACIAhA0QAgA1AAAKQAAAHgGADQgGACgWAAQgWAAgKgCgAAwBgQgDgBgBgCIgBgFIABgkIAAglQAAgxgDgdIgBgEQAAgEAEAAIAQABIAPACIAPgBIAQgBQADAAAAADIAAAEQgDAiAAAsIAAAmIABAmQgBAEgEABQgGABgVAAQgVAAgGgBgAMsAKQgQg3AAgIIABgVIABgWIgBgYIAAgXQAAgHADAAIAPABIAOABIAPgBIAOgBQAFAAAAArQAAAggHAcIgNA4QgCAHgNAAQgOAAgCgGgAAzhcQgLgIABgPQAAgNALgJQAKgIANAAQAOAAAKAIQALAJAAANQAAAfgjAAQgOAAgKgIg',
      );
    this.shape_3.setTransform(-4, 3.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_4.setTransform(-5.075, 0.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_5.setTransform(-5.85, 0.675);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_6.setTransform(-6.35, 1.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_7.setTransform(-7.4, 1.975);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgaCBQgJgLgBgQQABgRAJgKQALgLAPAAQAQAAAKALQAKAKAAARQAAAQgKALQgJAKgRABQgPgBgLgKgAgSAoQgSg/AAgIIABgYIABgXIgBgbIgBgaQAAgIAEABIARAAIAPABIAQgBIARAAQADAAAAAuQAAAkgFAgIgQA/QgCAGgNAAQgQAAgCgFg',
      );
    this.shape_8.setTransform(79.55, 0.8);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_9.setTransform(66.225, 1.75);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCGQgEgBgBgCIgBgGIABgoIAAgpQAAg2gDghIgBgEQAAgEAFAAIARABIAQABIARgBIARgBQAFAAgBAEIAAAEQgEAmAAAxIABArIAAAqQAAAEgFABQgHABgXAAQgWAAgHgBgAgahLQgLgJAAgQQAAgPAMgKQALgJAOAAQAQAAALAJQAMAKAAAPQAAAignAAQgOAAgMgJg',
      );
    this.shape_10.setTransform(53.15, 0.875);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_11.setTransform(30.125, 1.75);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_12.setTransform(11.975, 4.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AguB2QgkgGAAgJQAAgDAIgkQABgEADAAIACAAQAfAPAZAAQANAAAOgHQARgJAAgMIAAgNQgUASgeABQglgBgYgaQgXgZAAglQAAglAWgZQAXgZAlAAQAdAAAPAVQADAEACAAQABABAAgIQAAgPAEAAIAiADIAfADQAEACAAAEIgBAoIgBAoIAAAYIAAAXQAAA4gXAYQgYAZg4AAQgQAAgcgGgAgWg7QgKALAAAOQAAAPAKAKQAKAJANAAQAOAAAJgJQAKgKAAgPQAAgOgKgLQgJgKgOAAQgOAAgJAKg',
      );
    this.shape_13.setTransform(-10.475, 7.25);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AAiBdQgEgBgBgEIgBgMQgBgIgCgBIAAAAIAAAAQACABgVANQgWANgSAAQg0AAgJguQgFgXAAgnQAAgtAHgaQADgIAGAAIAbAAIAbAAQAGAAAAAGIAAADQgEAbAAAbQAAAiACAMQADAVAWABQAIAAAKgIQAKgIABgIIAAhhQAAgGABgCQABgCAGAAIAdAAIAdABQAFAAABADIABAEIgCAsIgBAqIABAqIABAqQAAAFgFACQgHACgYAAIgegBg',
      );
    this.shape_14.setTransform(-43.075, 5.05);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_15.setTransform(-65.325, 4.675);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgkCIQgGAAABgFIACggIABgfQAAgHgEgHQgYgigshDQgFgIABgFIgCgjIgBgjQAAgGAEAAIAkAAIAlABQAEAAAAADIgBAfIgBAdQAAAGARAXQAOATAIAKIAVgcQARgXAAgGIgBgdIgCgdQAAgFACgBIAEAAIAkgBIAjAAQAEAAAAAIIAAAfIABAgQAAAIgDAGQgaAzgsA2QgGAIAAAIIABAeIABAfQAAABAAABQAAAAAAABQgBAAAAABQAAAAAAAAIgGABQgGABgcAAQgcAAgIgBg',
      );
    this.shape_16.setTransform(-88.3, 0.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_17.setTransform(-5.95, 0.175);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_18.setTransform(-6.65, 0.45);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_19.setTransform(-6.625, 0.225);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        'AimB+IgNgBQgFgBABgEIAAhxQAAghgFgYIgBgCQAAgBABAAQAAgBAAAAQAAAAABgBQAAAAAAAAQAGgCAQgDQAQgCAHAAQAFAAABAHQABAIABAAQgBAAAOgIQAOgIALAAQAgAAATAVQASAUAAAfQAAAggSAUQgTAWgfAAQgLAAgNgGIgMgFQAAAAgBAAQAAAAAAABQAAAAAAABQgBABAAABIABAXIABAWQAAAFgFAAgAh+gLQgGAJAAALQAAAMAGAJQAHAJAMAAQAaAAAAgeQAAgLgHgJQgIgJgLAAQgMAAgHAJgAlDBAQgWgVAAgjQAAggAUgWQAUgWAhAAQAcAAAUAUQATAVAAAbQAAAPgJACIgeADIg0AFQADAJAKAFQAIAEALAAQANAAANgHIAMgHQACACAIANQAHAOAAADIgCAEQgSATgmAAQgjAAgVgUgAkkgXQgHAHABAKQAAAEAEAAQAKAAAXgDQAFgBABgCQAAgJgHgHQgGgHgKAAQgIAAgGAIgAnaBAQgVgVgBgjQAAggAUgWQAVgWAgAAQAdAAATAUQAUAVAAAbQAAAPgJACIgfADIg0AFQADAJAKAFQAIAEALAAQAOAAANgHIALgHQADACAHANQAIAOgBADIgCAEQgSATglAAQgjAAgWgUgAm7gXQgGAHAAAKQAAAEAFAAQAKAAAXgDQAFgBAAgCQAAgJgHgHQgGgHgJAAQgJAAgGAIgAJ+BLQgHgIAAgMQAAgMAHgIQAIgIAMAAQAMAAAJAIQAHAIAAAMQAAAMgHAIQgIAIgNAAQgMAAgIgIgABOA9QgRgWAAgdQAAghASgUQASgWAiAAQAXAAANAQIABABQABAAACgHQACgHACAAQAGAAAPADIAUAFQABAAABAAQAAABAAAAQABAAAAABQAAAAAAAAIgBADQgEAbAAAdIABAhIABAhQABAGgGABQgSABgYAAQgCAAgBgIQgBgJgCAAIgCADQgRAQgTAAQgcAAgTgWgAB2gMQgIAIAAALQAAAMAIAJQAJAIALAAQAMAAAJgIQAHgIABgNQgBgLgHgIQgIgIgNAAQgNAAgHAIgAIIAyIABgdIAAgcQAAgHgHAAIgCAAIgCABQgFAAgBgEIABgIIAAgHIAAgJIgBgJQAAgDAKgBQAFAAABgDQAAgFAAgMIAAgSQAAgRACAAIAMACIAMACIAWACQABAAABABQAAAAABAAQAAAAABABQAAAAAAABIgBASIgBASQAAAHAEAAIAQgBIAPAAQABAAABAAQAAAAABAAQAAABAAAAQABABAAAAIgBAKIgBAKIABALIAAAKQAAADgFAAIgKAAIgKgBIgKAAQgCAAAAAHIAAAJIAAALQAAAMADAFQADAGAMAAIALgCIAJgBQABAAAAAAQABAAAAAAQABABAAAAQAAABAAABIgBANIgBANIgBAGIgFADQgTAKgXAAQgqAAAAgggAD5AyIABgdIABgcQgBgHgHAAIgCAAIgCABQgFAAgBgEIABgIIAAgHIAAgJIgBgJQAAgDAKgBQAFAAABgDQAAgFAAgMIAAgSQAAgRACAAIAMACIAMACIAWACQABAAABABQABAAAAAAQAAAAABABQAAAAAAABIgBASIgBASQAAAHAEAAIAQgBIAPAAQABAAABAAQAAAAABAAQAAABAAAAQABABAAAAIgBAKIgBAKIABALIAAAKQAAADgFAAIgKAAIgJgBIgLAAQgCAAgBAHIAAAJIAAALQABAMADAFQADAGAMAAIALgCIAJgBQABAAAAAAQABAAAAAAQABABAAAAQAAABAAABIgBANIgBANIgBAGIgFADQgTAKgXAAQgqAAAAgggAovBQIgGgCIgDgEIgVgnQgRgggEgDQgQAGAAACIABAhIABAiQAAAEgEABIgcABIgZgBQgEgBAAgEIABgwIACguIgCgzIgBg0QAAgBAAAAQAAgBABAAQAAAAABgBQAAAAABAAIAOABIANAAIAPAAIANgBQABAAABAAQAAABAAAAQABAAAAABQAAAAAAABIgBAhIgCAgQABANAGAAQASAAAJgKQAIgHAHgSIAQgqQABgEAFAAIAMABIALAAIAMAAIALAAQABAAABAAQABAAAAAAQABABAAAAQAAABAAABQAAAFgGASQgTA4gXAOQgFACAAACIAbArQAbAsAAAJQAAAGgFACQgEABgTAAQgTAAgHgBgAG2BQQgBAAgBgBQAAAAgBAAQAAAAgBgBQAAAAAAAAIgBgFIABgeIAAgeQAAgpgDgZIAAgDQAAgBAAAAQABgBAAAAQABAAAAgBQABAAABAAIANABIAMABIANgBIAMAAQABAAABAAQABAAAAABQABAAAAAAQAAABAAABIAAACQgDAdgBAlIABAfIAAAgQAAABAAABQAAAAAAABQgBAAAAAAQgBABgBAAQgFABgSAAQgRAAgFgBgAKFAIQgOguAAgGIAAgSIABgSIgBgUIAAgTQAAgGADAAIAMABIAMAAIANAAIAMgBQADAAAAAkQAAAagFAYIgLAvQgCAFgKAAQgMAAgBgFgAG4hMQgJgHAAgMQAAgMAJgHQAJgHALAAQAMAAAJAHQAIAHABAMQgBAZgdAAQgLAAgJgGg',
      );
    this.shape_20.setTransform(-4.8, 1.125);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_21.setTransform(-4.425, 3.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_17 }] }, 11)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102.7, -24.4, 191.8, 51.2);

  (lib.verticalMeter = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1),
    );

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#7AA8F9').ss(1, 1, 1).p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape.setTransform(16.5, 139.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#7AA8F9').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_1.setTransform(16.5, 139.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_2.setTransform(16.5, 210.05);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#7AA8F9').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_3.setTransform(16.5, 210.05);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_4.setTransform(16.5, 69);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#7AA8F9').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_5.setTransform(16.5, 69);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AiG2AIENAAIAAK8IkNAAgAiGq/IENAAIAAK8IkNAAgAiGAEIENAAIAAK8IkNAAgAiGLFIENAAIAAK8IkNAAg',
      );
    this.shape_6.setTransform(16.5, 139.85);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#7AA8F9')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_7.setTransform(16.5, 139.85);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_8.setTransform(16.5, 139.6);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_9.setTransform(16.5, 139.6);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_10.setTransform(16.5, 210.05);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#BBE42E').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_11.setTransform(16.5, 210.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_12.setTransform(16.5, 69);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_13.setTransform(16.5, 69);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#BBE42E')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_14.setTransform(16.5, 139.85);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f('#BBE42E').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_15.setTransform(16.5, 245.725);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGQgIAAq8IENAAIAAK8gAiGFcIAAq6IENAAIAAK6gAiGlkIAAq7IENAAIAAK7g');
    this.shape_16.setTransform(16.5, 104.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#BBE42E')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_17.setTransform(16.5, 210.475);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_18.setTransform(16.5, 69.225);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#BBE42E')
      .s()
      .p('AiGQgIAAq7IENAAIAAK7gAiGFfIAAq7IENAAIAAK7gAiGlkIAAq7IENAAIAAK7g');
    this.shape_19.setTransform(16.5, 175.1);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics.f('#7AA8F9').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_20.setTransform(16.5, 33.975);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1, p: { y: 139.6 } },
            { t: this.shape, p: { y: 139.6 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_14 },
              { t: this.shape_6 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9, p: { y: 139.6 } },
              { t: this.shape_8, p: { y: 139.6 } },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_7 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_14 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_1, p: { y: 69 } },
              { t: this.shape, p: { y: 69 } },
              { t: this.shape_3 },
              { t: this.shape_2 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_6 },
              { t: this.shape_1, p: { y: 69 } },
              { t: this.shape, p: { y: 69 } },
              { t: this.shape_11 },
              { t: this.shape_10 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14 },
              { t: this.shape_6 },
              { t: this.shape_9, p: { y: 69 } },
              { t: this.shape_8, p: { y: 69 } },
              { t: this.shape_11 },
              { t: this.shape_10 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(2, -2, 29, 283.7);

  (lib.ruletext = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 0, 0);

  (lib.ruleheader = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAnQgKgOAAgZQAAgZAKgOQAJgOASAAQARAAAKANQAJANAAAVIAAANIgxAAQABAOAEAGQAFAGAJAAQAHAAAGgBQAGgCAGgEIAAAUQgMAIgQAAQgVAAgJgPgAgHgcQgEAGAAAMIAZAAQAAgLgDgGQgEgHgGAAQgFAAgDAGg',
      );
    this.shape.setTransform(116.675, 132.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#000000').s().p('AgMBIIAAiPIAYAAIAACPg');
    this.shape_1.setTransform(110, 130.775);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAYAAIAAA7QAAAYAKAAQAJAAACgIQAEgIAAgPIAAg0IAYAAIAABnIgUAAIgCgOIgBAAQgHAQgQAAQgOAAgGgKg',
      );
    this.shape_2.setTransform(102.95, 132.9);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgJAAIAAA1IgaAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgFAIgKAGIAdA8gAgQgFIAHAAQARAAAAgVQgBgTgRAAIgGAAg',
      );
    this.shape_3.setTransform(93.9, 131.225);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p('AgeBEIAAiHIA8AAIAAAWIgiAAIAAAgIAgAAIAAAVIggAAIAAAlIAiAAIAAAXg');
    this.shape_4.setTransform(81.2, 131.225);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AARBEIgoheIAAAAIABASIAAANIAAA/IgYAAIAAiHIAeAAIAnBcIABAAIgBgSIgBgMIAAg+IAZAAIAACHg',
      );
    this.shape_5.setTransform(71.05, 131.225);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA9QgLgJgFgPQgFgQAAgVQAAgiAMgRQAMgSAXAAQARAAAKAIQALAJAFAQQAFAPAAAVQAAAVgFAQQgFAQgLAIQgLAJgQAAQgPAAgLgJgAgUAAQAAAvAUAAQALAAAFgMQAFgLAAgYQAAgugVAAQgUAAAAAug',
      );
    this.shape_6.setTransform(59.525, 131.2);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f('#000000').s().p('AgkBFIAziJIAWAAIgyCJg');
    this.shape_7.setTransform(50.1, 131.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA9QgLgJgFgPQgFgQAAgVQAAgiAMgRQAMgSAXAAQARAAAKAIQALAJAFAQQAFAPAAAVQAAAVgFAQQgFAQgLAIQgLAJgQAAQgPAAgLgJgAgUAAQAAAvAUAAQALAAAFgMQAFgLAAgYQAAgugVAAQgUAAAAAug',
      );
    this.shape_8.setTransform(40.625, 131.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgIAAIAAA1IgaAAIAAiHIAfAAQAsAAAAAnQAAANgFAJQgEAIgLAGIAcA8gAgPgFIAFAAQASAAgBgVQAAgTgRAAIgFAAg',
      );
    this.shape_9.setTransform(30.7, 131.225);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p('AgdBEIAAiHIA8AAIAAAWIgiAAIAAAgIAfAAIAAAVIgfAAIAAAlIAiAAIAAAXg');
    this.shape_10.setTransform(21.4, 131.225);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p('AgkBEIAAgTIArheIgqAAIAAgWIBGAAIAAATIgrBdIAsAAIAAAXg');
    this.shape_11.setTransform(13.1, 131.225);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AgcBKIgGgBIAAgVIAEAAIADABQAEAAACgCQADgBACgEIAEgMIABgGIgehmIAaAAIAMAzIADAKIAAAJIABAAIABgIIADgLIALgzIAaAAIgfBxQgGAUgHAIQgIAIgMAAIgGgBg',
      );
    this.shape_12.setTransform(108.275, 105.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#000000').s().p('AgLBIIAAiPIAXAAIAACPg');
    this.shape_13.setTransform(101.75, 101.375);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AgmBMIAAiVIAUAAIAEAOIABAAQAFgJAFgDQAEgEAHAAQAPAAAIAOQAIAPAAAaQAAAYgIAOQgIAOgOAAQgHAAgFgEQgGgEgEgHIgBAAIABAKIAAAHIAAAqgAgJguQgEAHAAAQIAAAFQAAAPAEAHQADAHAHAAQANAAAAgfQAAgigNAAQgHAAgDAIg',
      );
    this.shape_14.setTransform(94.875, 105.575);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p('AgLBJIAAhoIAXAAIAABogAgNg5QAAgOANAAQANAAAAAOQAAAOgNAAQgNAAAAgOg');
    this.shape_15.setTransform(87.6, 101.35);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACAEQACACAEAAQAGAAAFgCIAAATQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_16.setTransform(82.3, 102.4);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f('#000000').s().p('AgMBIIAAiPIAYAAIAACPg');
    this.shape_17.setTransform(77.05, 101.375);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAZAAIAAA7QgBAYAKAAQAJAAACgIQAEgJAAgOIAAg0IAYAAIAABnIgUAAIgCgNIgBAAQgIAPgPAAQgNAAgHgKg',
      );
    this.shape_18.setTransform(70, 103.5);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        'AAkBEIAAhFIABgOIABgQIgBAAIgbBjIgUAAIgahjIgBAAIABARIAAANIAABFIgYAAIAAiHIAkAAIAYBcIABAAIAZhcIAjAAIAACHg',
      );
    this.shape_19.setTransform(57.925, 101.825);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA0QgHgBgGgDIAAgYQAFAEAGACQAHACAHABQAJgBAAgJQAAgEgCgDQgDgEgJgFQgKgFgFgGQgFgIAAgLQAAgOAIgIQAJgIANAAQAIAAAHADQAHACAGADIgHATIgJgEQgFgCgFAAQgJAAAAAIQAAAAAAABQAAAAABABQAAAAAAABQAAABABAAIAEAFIAJAFQAJAGAGAHQAGAGAAANQAAAQgJAHQgIAJgPAAQgIAAgGgCg',
      );
    this.shape_20.setTransform(43.675, 103.4);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p('AgdBEIAAiHIA7AAIAAAWIghAAIAAAlIAfAAIAAAVIgfAAIAAA3g');
    this.shape_21.setTransform(36.475, 101.825);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics.f('#000000').s().p('AgMBEIAAiHIAZAAIAACHg');
    this.shape_22.setTransform(29.7, 101.825);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p('AgOBEIgiiHIAbAAIARBMIACAKIACALIAAAKIABgKIACgLIACgKIARhMIAbAAIgiCHg');
    this.shape_23.setTransform(22.325, 101.825);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA1QgHgCgGgDIAAgYQAFADAGADQAHADAHAAQAJAAAAgKQAAgEgCgDQgDgEgJgEQgKgGgFgHQgFgHAAgMQAAgNAIgIQAJgIANAAQAIAAAHACQAHACAGAEIgHATIgJgEQgFgDgFAAQgJABAAAHQAAABAAABQAAAAABABQAAAAAAABQAAAAABABIAEAEIAJAHQAJAFAGAGQAGAIAAALQAAARgJAHQgIAJgPAAQgIAAgGgBg',
      );
    this.shape_24.setTransform(109.275, 132.8);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg9QgBgLgCgFQgCgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIATAAIAEAOIABAAQAHgQAPAAQANAAAHAJQAHAKAAASIAABEg',
      );
    this.shape_25.setTransform(100.95, 132.7);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p('AgLBEIAAhwIgaAAIAAgXIBLAAIAAAXIgZAAIAABwg');
    this.shape_26.setTransform(83.4, 131.225);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#000000')
      .s()
      .p(
        'AgDBGQgFgDgFgHIgBAAIgEALIgUAAIAAiPIAZAAIAAAkIAAAHIgBALIABAAQAEgIAGgEQAFgDAHAAQAOAAAIAOQAIAOAAAYQAAAZgIAPQgIAOgOAAQgIAAgEgDgAgKgEQgDAGAAAOIAAAFQAAAQAEAIQADAHAHAAQAGAAADgIQAEgIAAgRQAAgfgNAAQgIAAgDAIg',
      );
    this.shape_27.setTransform(62.925, 130.875);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA1QgHgCgGgDIAAgYQAFADAGADQAHADAHAAQAJAAAAgKQAAgEgCgDQgDgEgJgEQgKgGgFgHQgFgHAAgMQAAgNAIgIQAJgIANAAQAIAAAHACQAHACAGAEIgHATIgJgEQgFgDgFAAQgJABAAAHQAAABAAABQAAAAABABQAAAAAAABQAAAAABABIAEAEIAJAHQAJAFAGAGQAGAIAAALQAAARgJAHQgIAJgPAAQgIAAgGgBg',
      );
    this.shape_28.setTransform(51.075, 132.8);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg9QAAgLgCgFQgDgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIAUAAIADAOIABAAQAHgQAPAAQANAAAHAJQAHAKAAASIAABEg',
      );
    this.shape_29.setTransform(42.75, 132.7);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAnQgKgOAAgZQAAgZAKgOQAJgOASAAQARAAAKANQAJANAAAVIAAANIgxAAQABAOAEAGQAFAGAJAAQAHAAAGgBQAGgCAGgEIAAAUQgMAIgQAAQgVAAgJgPgAgHgcQgEAGAAAMIAZAAQAAgLgDgGQgEgHgGAAQgFAAgDAGg',
      );
    this.shape_30.setTransform(33.675, 132.825);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#000000')
      .s()
      .p('AgMBEIAAhwIgZAAIAAgXIBLAAIAAAXIgZAAIAABwg');
    this.shape_31.setTransform(25.2, 131.225);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#000000')
      .s()
      .p(
        'AgcBKIgGgBIAAgVIAEAAIADABQAEAAACgCQADgBACgEIAEgMIABgGIgehmIAaAAIAMAzIADAKIAAAJIABAAIABgIIADgLIALgzIAaAAIgfBxQgGAUgHAIQgIAIgMAAIgGgBg',
      );
    this.shape_32.setTransform(110.275, 105.675);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics.f('#000000').s().p('AgLBIIAAiPIAYAAIAACPg');
    this.shape_33.setTransform(103.75, 101.375);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#000000')
      .s()
      .p('AgLBJIAAhoIAXAAIAABogAgMg5QAAgOAMAAQAOAAAAAOQAAAOgOAAQgMAAAAgOg');
    this.shape_34.setTransform(89.6, 101.35);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIAQAAIAAAWIATAAIAAAVIgTAAIAAAyQAAAGACAEQACACAFAAQAGAAAFgCIAAATQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_35.setTransform(84.3, 102.4);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAYAAIAAA7QAAAYAKAAQAJAAADgIQADgJAAgOIAAg0IAYAAIAABnIgUAAIgCgNIgCAAQgGAPgQAAQgOAAgGgKg',
      );
    this.shape_36.setTransform(72, 103.5);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAZAAIAAA7QgBAYAKAAQAJAAACgIQAEgIAAgPIAAg0IAYAAIAABnIgUAAIgCgOIgBAAQgIAQgPAAQgNAAgHgKg',
      );
    this.shape_37.setTransform(97, 132.9);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgIAAIAAA1IgbAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgEAIgLAGIAcA8gAgPgFIAGAAQARAAAAgVQgBgTgRAAIgFAAg',
      );
    this.shape_38.setTransform(87.95, 131.225);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#000000')
      .s()
      .p(
        'AAOBEIgWg1IgIAAIAAA1IgZAAIAAiHIAfAAQAsAAAAAnQAAANgFAJQgEAIgKAGIAbA8gAgQgFIAGAAQARAAAAgVQAAgTgRAAIgGAAg',
      );
    this.shape_39.setTransform(53.8, 131.225);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgJAAIAAA1IgaAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgFAIgJAGIAcA8gAgQgFIAHAAQAQAAABgVQAAgTgSAAIgGAAg',
      );
    this.shape_40.setTransform(44.05, 131.225);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#000000')
      .s()
      .p(
        'AAkBEIAAhFIABgOIABgQIgBAAIgbBjIgUAAIgahjIgBAAIABARIAAANIAABFIgYAAIAAiHIAkAAIAYBcIABAAIAZhcIAjAAIAACHg',
      );
    this.shape_41.setTransform(59.925, 101.825);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics.f('#000000').s().p('AgMBEIAAiHIAZAAIAACHg');
    this.shape_42.setTransform(31.7, 101.825);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgIAAgRIAAg0IgKAAIAAgMIAMgHIAGgXIAQAAIAAAWIASAAIAAAUIgSAAIAAAzQAAAGACADQACADAEAAQAGAAAGgDIAAAUQgJAFgLAAQgMAAgGgIg',
      );
    this.shape_43.setTransform(106.05, 161.2);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhnIAXAAIAABngAgNg5QAAgOANAAQANAAAAAOQAAAOgNAAQgNAAAAgOg');
    this.shape_44.setTransform(100.75, 160.15);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgHAAgPQAAgIAFgHQAFgGAJgDQgEgCgDgDQgDgEAAgGQAAgGADgCQACgEAFgFQgGgEgEgHQgDgJAAgJQAAgRAJgJQAJgJAQAAIAIABIAFABIAeAAIAAAPIgMACQADAHAAAJQAAAQgJAKQgJAJgPAAIgIgBIgDAEIgBADQAAAHALAAIAQAAQANAAAGAHQAHAHAAAOQAAATgMAJQgMALgWAAQgRAAgKgIgAgPAiQgDAEAAAGQAAAHAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgBQgDgCgIAAIgMAAQgFAAgCACgAgKgnQAAASAKAAQAIAAAAgSQAAgSgIAAQgKAAAAASg',
      );
    this.shape_45.setTransform(94.075, 164.4);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhnIAYAAIAABngAgNg5QAAgOANAAQANAAAAAOQAAAOgNAAQgNAAAAgOg');
    this.shape_46.setTransform(87.4, 160.15);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMgBgWQAAgXgGgLQgGgKgNAAIgHAAg',
      );
    this.shape_47.setTransform(80, 160.625);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAYAAIAAA8QAAAXAKAAQAJAAACgIQAEgJAAgOIAAg0IAYAAIAABnIgUAAIgCgNIgBAAQgHAPgQAAQgOAAgGgKg',
      );
    this.shape_48.setTransform(43.55, 162.3);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAvQgJgIgEgMQgFgNAAgOQAAgPAFgMQADgMAKgHQAIgHANAAQASAAALAOQAKAOABAZQAAAOgFANQgEAMgIAIQgJAHgOAAQgNAAgIgHgAgKgYQgDAJAAAPQAAAQADAIQADAJAHAAQAIAAADgJQADgIAAgQQAAgPgDgIQgDgJgIAAQgHAAgDAIg',
      );
    this.shape_49.setTransform(34.2, 162.2);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAANARQAOARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMAAgWQgBgXgGgLQgHgKgMAAIgHAAg',
      );
    this.shape_50.setTransform(24.45, 160.625);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#000000')
      .s()
      .p(
        'AgDBGQgFgDgFgHIgBAAIgEALIgUAAIAAiPIAZAAIAAAkIAAAHIgBALIABAAQAEgIAGgEQAFgDAHAAQAOAAAIAOQAIAOAAAYQAAAZgIAPQgIAOgOAAQgIAAgEgDgAgKgEQgDAGAAAOIAAAFQAAAQAEAIQADAHAHAAQAGAAADgIQAEgIAAgRQAAgfgNAAQgIAAgDAIg',
      );
    this.shape_51.setTransform(102.825, 130.875);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIARAAIAAAWIASAAIAAAVIgSAAIAAAyQgBAGACADQACADAFAAQAGAAAFgDIAAAUQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_52.setTransform(91.5, 131.8);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAYAAIAABmgAgMg5QAAgPAMAAQAOAAAAAPQAAAOgOAAQgMAAAAgOg');
    this.shape_53.setTransform(86.2, 130.75);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgHAAgOQAAgJAFgHQAFgGAJgDQgEgCgDgEQgDgEAAgFQAAgGADgDQACgDAFgFQgGgDgEgJQgDgIAAgKQAAgQAJgJQAJgKAQAAIAIABIAFABIAeAAIAAAPIgMADQADAHAAAJQAAAQgJAKQgJAJgPAAIgIgBIgDADIgBAFQAAAGALAAIAQAAQANAAAGAHQAHAHAAAPQAAASgMAKQgMAKgWAAQgRgBgKgHgAgPAiQgDAEAAAGQAAAHAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgCQgDgCgIAAIgMAAQgFAAgCADgAgKgnQAAASAKAAQAIAAAAgSQAAgTgIAAQgKAAAAATg',
      );
    this.shape_54.setTransform(79.525, 135);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAXAAIAABmgAgNg5QAAgPANAAQANAAAAAPQAAAOgNAAQgNAAAAgOg');
    this.shape_55.setTransform(72.85, 130.75);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMABgWQAAgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_56.setTransform(65.45, 131.225);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgHAAgOQAAgJAFgHQAFgGAJgDQgEgCgDgEQgDgEAAgFQAAgGADgDIAHgIQgGgDgEgJQgDgIAAgKQAAgQAJgJQAJgKAQAAIAIABIAFABIAeAAIAAAPIgMADQADAHAAAJQAAAQgJAKQgJAJgPAAIgIgBIgDADIgBAFQAAAGALAAIAQAAQANAAAGAHQAHAHAAAPQAAASgMAKQgMAKgWAAQgRgBgKgHgAgPAiQgDAEAAAGQAAAHAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgCQgDgCgIAAIgMAAQgFAAgCADgAgKgnQAAASAKAAQAIAAAAgSQAAgTgIAAQgKAAAAATg',
      );
    this.shape_57.setTransform(38.875, 135);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#000000')
      .s()
      .p(
        'AAMA1IAAg9QAAgLgBgFQgDgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIAUAAIADAOIABAAQAHgQAPAAQANAAAHAJQAHAKAAASIAABEg',
      );
    this.shape_58.setTransform(29.8, 132.7);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAXAAIAABmgAgNg5QAAgPANAAQANAAAAAPQAAAOgNAAQgNAAAAgOg');
    this.shape_59.setTransform(22.7, 130.75);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#000000')
      .s()
      .p(
        'AgTBEQgIgCgIgEIAAgaQAIAEAIADQAIACAHAAQAGAAAEgEQADgEAAgGQAAgFgBgDQgBgDgEgEIgLgIQgIgEgGgFQgFgFgEgHQgDgHAAgLQAAgRAKgKQALgLARAAQAIAAAIACQAIADAHAEIgHAXQgNgIgKAAQgGAAgDAEQgEADAAAGQAAAFACADQABAEAEADIALAHQANAIAGAIQAHAJAAANQAAAMgFAKQgFAJgJAFQgJAGgLAAQgJAAgHgCg',
      );
    this.shape_60.setTransform(16.275, 131.2239);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACAEQACACAEAAQAGAAAGgCIAAATQgJAFgLAAQgMAAgGgIg',
      );
    this.shape_61.setTransform(81.3, 102.4);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics.f('#000000').s().p('AgMBIIAAiPIAZAAIAACPg');
    this.shape_62.setTransform(76.05, 101.375);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAZAAIAAA7QgBAYALAAQAIAAACgIQADgJABgOIAAg0IAYAAIAABnIgUAAIgCgNIgBAAQgIAPgPAAQgNAAgHgKg',
      );
    this.shape_63.setTransform(69, 103.5);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#000000')
      .s()
      .p(
        'AgnBEIAAiHIAkAAQApAAAAAiQgBALgEAIQgFAIgIADIAAABQALACAEAIQAFAHAAANQAAATgLAKQgKALgTAAgAgNAuIAMAAQAOAAAAgUQAAgJgDgEQgFgFgHAAIgLAAgAgNgMIAKAAQAPAAgBgSQAAgQgPAAIgJAAg',
      );
    this.shape_64.setTransform(61.4, 131.225);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg9QAAgLgCgFQgDgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIAUAAIADAOIABAAQAHgQAPAAQANAAAHAJQAHAKAAASIAABEg',
      );
    this.shape_65.setTransform(40.95, 132.7);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACADQACADAEAAQAFAAAHgDIAAAUQgJAFgLAAQgNAAgFgIg',
      );
    this.shape_66.setTransform(105.5, 131.8);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAYAAIAABmgAgMg5QgBgPANAAQANAAAAAPQAAAOgNAAQgNAAABgOg');
    this.shape_67.setTransform(86.85, 130.75);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMgBgWQAAgXgGgLQgHgKgMAAIgHAAg',
      );
    this.shape_68.setTransform(79.45, 131.225);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAuQgJgHgFgMQgEgMAAgPQAAgPAEgMQAFgMAJgHQAIgHANAAQASAAALAOQAKAOABAZQAAAOgFAMQgDANgJAHQgJAIgOAAQgNAAgIgIgAgKgYQgEAIABAQQgBAQAEAJQADAIAHAAQAHAAAEgIQADgJAAgQQAAgQgDgIQgEgIgHAAQgHAAgDAIg',
      );
    this.shape_69.setTransform(33.65, 132.8);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics.f('#000000').s().p('AgLBIIAAiPIAYAAIAACPg');
    this.shape_70.setTransform(103.75, 101.375);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgHAFgGQAGgGAHAAIAJACIgDAaQgDgBgFAAQgJAAgFAGQgDAIAAALIAAA1g',
      );
    this.shape_71.setTransform(86.625, 162.1);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAvQgIgIgFgMQgDgNAAgOQAAgPADgMQAFgMAIgHQAJgHANAAQASAAAKAOQALAOAAAZQAAAOgDANQgEAMgJAIQgJAHgOAAQgNAAgJgHgAgKgYQgEAJAAAPQAAAQAEAIQADAJAHAAQAHAAAEgJQADgIAAgQQAAgPgDgIQgEgJgHAAQgHAAgDAIg',
      );
    this.shape_72.setTransform(78.25, 162.2);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f('#000000')
      .s()
      .p(
        'AAkA1IAAg8QAAgXgLAAQgGAAgEAIQgCAHAAAQIAAA0IgZAAIAAg8QAAgXgJAAQgIAAgDAJQgDAIAAAQIAAAyIgYAAIAAhnIATAAIADANIABAAQAHgPARAAQAKAAAEAEQAFAFACAGIACAAQADgHAHgEQAFgEAIAAQAaAAAAAmIAABDg',
      );
    this.shape_73.setTransform(66.5, 162.1);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgHAFgGQAGgGAHAAIAJABIgDAbQgDgBgFAAQgJgBgFAIQgDAHAAALIAAA1g',
      );
    this.shape_74.setTransform(87.675, 132.7);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAuQgIgHgEgMQgFgMAAgPQAAgPAFgMQADgMAJgHQAJgHANAAQASAAALAOQALAOAAAZQAAAOgEAMQgFANgIAHQgJAIgOAAQgNAAgJgIgAgKgYQgDAIgBAQQABAQADAJQAEAIAGAAQAIAAADgIQADgJAAgQQAAgQgDgIQgDgIgIAAQgGAAgEAIg',
      );
    this.shape_75.setTransform(79.3, 132.8);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAPAAIAAAWIATAAIAAAVIgTAAIAAAyQABAGACADQACADAEAAQAFAAAHgDIAAAUQgJAFgLAAQgNAAgFgIg',
      );
    this.shape_76.setTransform(71.65, 131.8);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f('#000000')
      .s()
      .p(
        'AgeA7QgIgOAAgaQAAgYAIgOQAIgPAOAAQAOAAAIAQIABAAIgBgLIAAgHIAAgkIAZAAIAACPIgUAAIgEgLIgBAAQgFAHgFADQgEADgHAAQgPAAgIgOgAgNATQAAAhANAAQAHAAADgHQAEgHAAgQIAAgFQAAgQgEgGQgDgHgHAAQgNAAAAAfg',
      );
    this.shape_77.setTransform(59.125, 130.875);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAYAAIAAA7QAAAYALAAQAIAAADgIQACgIAAgPIAAg0IAZAAIAABnIgTAAIgDgOIgCAAQgGAQgPAAQgPAAgGgKg',
      );
    this.shape_78.setTransform(49.8, 132.9);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f('#000000')
      .s()
      .p(
        'AAWBEIgHghIgdAAIgHAhIgcAAIAhiHIAgAAIAiCHgAgBgkIgCANIgHAjIAVAAIgHgiIgCgNIgCgMIgBALg',
      );
    this.shape_79.setTransform(40.05, 131.225);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f('#000000')
      .s()
      .p(
        'AgcBKIgGgBIAAgVIAEAAIADABQAEAAACgCQADgBACgEIAEgMIABgGIgehmIAaAAIAMAzIADAKIAAAJIABAAIABgIIADgLIALgzIAaAAIgfBxQgGAUgHAIQgIAIgMAAIgGgBg',
      );
    this.shape_80.setTransform(110.275, 105.675);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMAAgWQABgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_81.setTransform(103.15, 131.225);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAANARQAOARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMABgWQAAgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_82.setTransform(92.55, 131.225);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f('#000000')
      .s()
      .p(
        'AAkA1IAAg8QAAgXgKAAQgIAAgCAIQgDAHgBAQIAAA0IgXAAIAAg9QAAgWgKAAQgIAAgDAJQgCAJgBAPIAAAyIgZAAIAAhnIAUAAIADAOIACAAQAFgQATAAQAIAAAFAFQAFAEACAGIACAAQAEgHAFgEQAGgEAJAAQAaAAAAAlIAABEg',
      );
    this.shape_83.setTransform(76.55, 132.7);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAuQgJgHgFgMQgDgMAAgPQAAgPADgMQAEgMAKgHQAIgHANAAQASAAAKAOQALAOAAAZQAAAOgDAMQgEANgJAHQgJAIgOAAQgNAAgIgIgAgKgYQgEAIAAAQQAAAQAEAJQAEAIAGAAQAIAAADgIQADgJAAgQQAAgQgDgIQgDgIgIAAQgGAAgEAIg',
      );
    this.shape_84.setTransform(64.85, 132.8);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f('#000000')
      .s()
      .p(
        'AgRBJIAAhTIgMAAIAAgNIAMgHIAAgDQABgUAGgJQAGgKANAAIAKABIALAEIgGASIgFgBIgEgBQgEAAgCAEQgCADAAAJIAAAFIARAAIAAAUIgRAAIAABTg',
      );
    this.shape_85.setTransform(51.1, 130.725);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAFgXIARAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGABAEQACACAFAAQAGAAAFgCIAAATQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_86.setTransform(111.65, 102.4);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f('#000000')
      .s()
      .p(
        'AgWApQgJgOAAgbQAAgPAEgMQAEgMAJgHQAIgHANAAQAIAAAGACQAGABAFAEIgGAUQgJgGgIABQgIAAgDAIQgEAJAAAOQAAAhAPAAQALgBAKgHIAAAVQgFAEgGACQgGACgGAAQgTAAgKgNg',
      );
    this.shape_87.setTransform(105.025, 103.4);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAxQgFgEgDgIQgCgIAAgHQAAgRAJgHQAJgIAQgBIAMgBIAAgEQAAgJgCgEQgDgEgGAAQgIAAgMAHIgHgSQAOgJATAAQAPAAAHAJQAIAKAAATIAABDIgSAAIgEgOIAAAAQgFAIgGAEQgEAEgKAAQgIAAgGgFgAgKAVQAAANAJAAQAFAAAEgFQADgGAAgKIAAgJIgGAAQgPABAAAQg',
      );
    this.shape_88.setTransform(96.45, 103.4);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgIAFgFQAGgGAHAAIAJACIgDAaQgDgCgFAAQgJABgFAGQgDAIAAALIAAA1g',
      );
    this.shape_89.setTransform(89.475, 103.3);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIAQAAIAAAWIATAAIAAAVIgTAAIAAAyQAAAGACAEQADACAEAAQAFAAAGgCIAAATQgIAFgLAAQgNAAgFgIg',
      );
    this.shape_90.setTransform(82.7, 102.4);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f('#000000')
      .s()
      .p(
        'AgTBEQgIgCgIgEIAAgaQAIAEAIADQAIACAHAAQAGAAAEgEQADgEAAgGQAAgFgBgDQgBgDgEgEIgLgIQgIgEgGgFQgFgFgEgHQgDgHAAgLQAAgRAKgKQALgLARAAQAIAAAIACQAIADAHAEIgHAXQgNgIgKAAQgGAAgDAEQgEADAAAGQAAAFACADQABAEAEADIALAHQANAIAGAIQAHAJAAANQAAAMgFAKQgFAJgJAFQgJAGgLAAQgJAAgHgCg',
      );
    this.shape_91.setTransform(56.625, 101.8239);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f('#000000')
      .s()
      .p('AgLBJIAAhoIAYAAIAABogAgMg5QAAgOAMAAQAOAAAAAOQAAAOgOAAQgMAAAAgOg');
    this.shape_92.setTransform(84.3, 101.35);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f('#000000')
      .s()
      .p('AgNA0IgchnIAaAAIAMA2IACALIABALIAAAAIABgJIACgLIANg4IAaAAIgdBng');
    this.shape_93.setTransform(77.775, 103.4);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAYAAIAAA7QABAYAJAAQAJAAADgIQACgIAAgPIAAg0IAZAAIAABnIgTAAIgDgOIgCAAQgGAQgPAAQgPAAgGgKg',
      );
    this.shape_94.setTransform(91.1, 132.9);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f('#000000')
      .s()
      .p(
        'AAOBEIgWg1IgIAAIAAA1IgaAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgEAIgKAGIAcA8gAgQgFIAHAAQAQAAAAgVQABgTgSAAIgGAAg',
      );
    this.shape_95.setTransform(82.05, 131.225);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAuQgJgHgFgMQgDgMgBgPQABgPADgMQAFgMAJgHQAIgHANAAQASAAALAOQAKAOABAZQAAAOgFAMQgDANgJAHQgJAIgOAAQgNAAgIgIgAgKgYQgEAIABAQQgBAQAEAJQADAIAHAAQAHAAAEgIQADgJAAgQQAAgQgDgIQgEgIgHAAQgHAAgDAIg',
      );
    this.shape_96.setTransform(62, 132.8);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgHAFgGQAGgGAHAAIAJABIgDAbQgDgBgFAAQgJgBgFAIQgDAHAAALIAAA1g',
      );
    this.shape_97.setTransform(54.525, 132.7);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgHAFgGQAGgGAHAAIAJABIgDAbQgDgBgFAAQgJgBgFAIQgDAHAAALIAAA1g',
      );
    this.shape_98.setTransform(47.925, 132.7);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA0QgHgBgGgDIAAgYQAFAEAGACQAHACAHAAQAJAAAAgJQAAgEgCgDQgDgEgJgFQgKgFgFgGQgFgIAAgLQAAgOAIgIQAJgIANAAQAIAAAHADQAHACAGADIgHATIgJgEQgFgCgFAAQgJAAAAAIQAAAAAAABQAAAAABABQAAAAAAABQAAABABAAIAEAFIAJAFQAJAGAGAHQAGAGAAANQAAAQgJAHQgIAJgPAAQgIAAgGgCg',
      );
    this.shape_99.setTransform(84.275, 191.6);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgIAAgOQAAgJAFgGQAFgHAJgCQgEgCgDgDQgDgEAAgGQAAgGADgCQACgFAFgDQgGgFgEgIQgDgHAAgLQAAgQAJgJQAJgKAQAAIAIACIAFABIAeAAIAAAOIgMAEQADAGAAAJQAAARgJAIQgJAKgPAAIgIgBIgDAEIgBADQAAAHALAAIAQAAQANAAAGAHQAHAHAAAPQAAASgMAJQgMALgWgBQgRAAgKgHgAgPAjQgDADAAAHQAAAGAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgBQgDgDgIAAIgMAAQgFAAgCAEgAgKgnQAAASAKAAQAIAAAAgSQAAgSgIgBQgKABAAASg',
      );
    this.shape_100.setTransform(65.725, 193.8);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f('#000000')
      .s()
      .p('AgLBJIAAhoIAXAAIAABogAgNg5QAAgOANAAQANAAAAAOQAAAOgNAAQgNAAAAgOg');
    this.shape_101.setTransform(59.05, 189.55);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg8QAAgLgDgGQgCgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIATAAIAEANIABAAQAHgPAPAAQANAAAHAKQAHAJAAATIAABDg',
      );
    this.shape_102.setTransform(73.15, 162.1);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhnIAYAAIAABngAgMg5QAAgOAMAAQAOAAAAAOQAAAOgOAAQgMAAAAgOg');
    this.shape_103.setTransform(66.05, 160.15);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAYAAIAABmgAgMg5QAAgPAMAAQAOAAAAAPQAAAOgOAAQgMAAAAgOg');
    this.shape_104.setTransform(40.4, 130.75);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAnQgKgOAAgZQAAgZAKgOQAJgOASAAQARAAAKANQAJANAAAVIAAANIgxAAQABAOAEAGQAFAGAJAAQAHAAAGgBQAGgCAGgEIAAAUQgMAIgQAAQgVAAgJgPgAgHgcQgEAGAAAMIAZAAQAAgLgDgGQgEgHgGAAQgFAAgDAGg',
      );
    this.shape_105.setTransform(102.525, 103.425);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f('#000000')
      .s()
      .p('AgLBJIAAhoIAXAAIAABogAgNg5QAAgOANAAQANAAAAAOQAAAOgNAAQgNAAAAgOg');
    this.shape_106.setTransform(73.2, 101.35);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f('#000000')
      .s()
      .p(
        'AAMA1IAAg9QAAgKgBgGQgDgGgGAAQgHAAgDAIQgDAIAAARIAAAyIgZAAIAAhnIAUAAIACANIACAAQAHgPAPAAQANAAAHAJQAHAKAAATIAABDg',
      );
    this.shape_107.setTransform(82.55, 191.5);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA1QgHgCgGgDIAAgYQAFADAGADQAHACAHAAQAJAAAAgJQAAgEgCgDQgDgDgJgFQgKgGgFgHQgFgHAAgLQAAgOAIgIQAJgIANAAQAIAAAHADQAHABAGAFIgHATIgJgGQgFgCgFAAQgJAAAAAJQAAAAAAABQAAAAABABQAAAAAAABQAAABABAAIAEAFIAJAGQAJAFAGAGQAGAIAAALQAAAQgJAJQgIAIgPAAQgIAAgGgBg',
      );
    this.shape_108.setTransform(108.225, 162.2);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgIAAgRIAAg0IgKAAIAAgMIAMgHIAGgXIAQAAIAAAWIASAAIAAAUIgSAAIAAAzQAAAGABADQADADAEAAQAGAAAGgDIAAAUQgJAFgLAAQgMAAgGgIg',
      );
    this.shape_109.setTransform(101.65, 161.2);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhnIAXAAIAABngAgMg5QAAgOAMAAQAOAAAAAOQAAAOgOAAQgMAAAAgOg');
    this.shape_110.setTransform(96.35, 160.15);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMAAgWQABgXgHgLQgGgKgNAAIgHAAg',
      );
    this.shape_111.setTransform(75.6, 160.625);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgHAAgPQAAgIAFgHQAFgGAJgDQgEgCgDgDQgDgEAAgGQAAgGADgCQACgEAFgFQgGgEgEgHQgDgJAAgJQAAgRAJgJQAJgJAQAAIAIABIAFABIAeAAIAAAPIgMACQADAHAAAJQAAAQgJAKQgJAJgPAAIgIgBIgDAEIgBADQAAAHALAAIAQAAQANAAAGAHQAHAHAAAOQAAATgMAJQgMALgWAAQgRAAgKgIgAgPAiQgDAEAAAGQAAAHAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgBQgDgCgIAAIgMAAQgFAAgCACgAgKgnQAAASAKAAQAIAAAAgSQAAgSgIAAQgKAAAAASg',
      );
    this.shape_112.setTransform(49.025, 164.4);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg8QAAgLgCgGQgDgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIATAAIAEANIABAAQAHgPAPAAQANAAAHAKQAHAJAAATIAABDg',
      );
    this.shape_113.setTransform(39.95, 162.1);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhnIAYAAIAABngAgNg5QABgOAMAAQAOAAAAAOQAAAOgOAAQgMAAgBgOg');
    this.shape_114.setTransform(32.85, 160.15);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIAQAAIAAAWIATAAIAAAVIgTAAIAAAyQAAAGACADQACADAFAAQAGAAAFgDIAAAUQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_115.setTransform(67.75, 131.8);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAYAAIAAA7QABAYAJAAQAJAAADgIQACgIABgPIAAg0IAYAAIAABnIgTAAIgDgOIgCAAQgGAQgPAAQgPAAgGgKg',
      );
    this.shape_116.setTransform(55.45, 132.9);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgIAAgRIAAg0IgLAAIAAgMIANgHIAFgXIAQAAIAAAWIATAAIAAAUIgTAAIAAAzQAAAGACADQACADAFAAQAGAAAFgDIAAAUQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_117.setTransform(109.05, 161.2);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAYAAIAAA8QABAXAJAAQAJAAADgIQACgJAAgOIAAg0IAZAAIAABnIgTAAIgDgNIgCAAQgGAPgPAAQgPAAgGgKg',
      );
    this.shape_118.setTransform(46.55, 162.3);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAvQgIgIgEgMQgEgNgBgOQABgPAEgMQAEgMAIgHQAJgHANAAQASAAAKAOQAMAOgBAZQAAAOgDANQgFAMgIAIQgJAHgOAAQgNAAgJgHgAgKgYQgDAJgBAPQABAQADAIQADAJAHAAQAHAAAEgJQADgIAAgQQAAgPgDgIQgEgJgHAAQgHAAgDAIg',
      );
    this.shape_119.setTransform(37.2, 162.2);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIAQAAIAAAWIATAAIAAAVIgTAAIAAAyQABAGABADQACADAFAAQAGAAAFgDIAAAUQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_120.setTransform(91.95, 131.8);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAANARQAOARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMABgWQAAgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_121.setTransform(65.9, 131.225);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACADQACADAEAAQAGAAAGgDIAAAUQgJAFgLAAQgMAAgGgIg',
      );
    this.shape_122.setTransform(49.35, 131.8);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAZAAIAAA7QgBAYALAAQAIAAACgIQADgIABgPIAAg0IAYAAIAABnIgUAAIgCgOIgBAAQgIAQgPAAQgNAAgHgKg',
      );
    this.shape_123.setTransform(37.05, 132.9);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACADQACADAEAAQAGAAAFgDIAAAUQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_124.setTransform(75.55, 131.8);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f('#000000')
      .s()
      .p(
        'AgWApQgJgOAAgbQAAgOAEgMQAEgNAJgHQAIgHANAAQAIAAAGACQAGACAFADIgGAUQgJgGgIAAQgIAAgDAJQgEAJAAAOQAAAgAPABQALAAAKgIIAAAVQgFAEgGACQgGACgGAAQgTAAgKgNg',
      );
    this.shape_125.setTransform(68.925, 132.8);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAxQgFgEgDgIQgCgIAAgIQAAgQAJgHQAJgIARgBIALgBIAAgEQAAgJgCgDQgDgFgGAAQgIAAgMAHIgHgSQAPgJASAAQAPAAAHAJQAIAKAAASIAABEIgSAAIgEgOIAAAAQgFAIgGAEQgFAEgJAAQgIAAgGgFgAgKAUQAAAOAJAAQAFAAAEgGQAEgFgBgKIAAgJIgGAAQgPABAAAPg',
      );
    this.shape_126.setTransform(60.35, 132.8);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA2QgLgQAAgcQAAgQADgOQACgPAGgKQAGgLAKgHQAKgGAOAAQAJAAAIACIAAAWIgHgCIgIAAQgOAAgHAKQgHALgBAWIABAAQAGgQAOAAQAPAAAHAMQAIALAAAUQAAAOgEAKQgFALgIAGQgIAGgMAAQgRAAgKgQgAgHAGQgEAGAAAIIABANQACAGADAEQACAEAEAAQAFAAADgGQADgFAAgNQAAgWgLAAQgFAAgDAFg',
      );
    this.shape_127.setTransform(113.025, 101.825);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f('#000000')
      .s()
      .p(
        'AgVBEQgHgBgIgEIAAgYQAOAJANAAQAKAAAFgFQAEgFAAgKQAAgKgFgEQgGgFgNAAIgGAAIAAgVIAGAAQAMAAAFgFQAHgFgBgKQABgPgPAAQgFAAgGADQgEACgGAEIgKgSQAIgHAJgDQAIgDALAAQAQAAAJAJQAKAJAAARQgBALgFAIQgGAIgMAFIAAAAQAaAFAAAbQAAASgLALQgLALgUAAQgIAAgIgCg',
      );
    this.shape_128.setTransform(104, 101.825);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f('#000000')
      .s()
      .p('AgdBEIAAiHIA7AAIAAAWIghAAIAAAlIAfAAIAAAVIgfAAIAAA3g');
    this.shape_129.setTransform(35.575, 101.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_23, p: { x: 22.325 } },
            { t: this.shape_22, p: { x: 29.7, y: 101.825 } },
            { t: this.shape_21, p: { x: 36.475, y: 101.825 } },
            { t: this.shape_20, p: { x: 43.675 } },
            { t: this.shape_19, p: { x: 57.925, y: 101.825 } },
            { t: this.shape_18, p: { x: 70 } },
            { t: this.shape_17, p: { x: 77.05 } },
            { t: this.shape_16 },
            { t: this.shape_15, p: { x: 87.6, y: 101.35 } },
            { t: this.shape_14, p: { x: 94.875, y: 105.575 } },
            { t: this.shape_13, p: { x: 101.75, y: 101.375 } },
            { t: this.shape_12, p: { x: 108.275, y: 105.675 } },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9, p: { x: 30.7 } },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6, p: { x: 59.525 } },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1, p: { x: 110, y: 130.775 } },
            { t: this.shape, p: { x: 116.675, y: 132.825 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_19, p: { x: 59.925, y: 101.825 } },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_32, p: { x: 110.275, y: 105.675 } },
              { t: this.shape_31, p: { x: 25.2, y: 131.225 } },
              { t: this.shape_30, p: { x: 33.675, y: 132.825 } },
              { t: this.shape_29, p: { x: 42.75 } },
              { t: this.shape_28, p: { x: 51.075 } },
              { t: this.shape_27, p: { x: 62.925, y: 130.875 } },
              { t: this.shape_12, p: { x: 71.725, y: 135.075 } },
              { t: this.shape_26, p: { x: 83.4 } },
              { t: this.shape, p: { x: 91.875, y: 132.825 } },
              { t: this.shape_25 },
              { t: this.shape_24, p: { x: 109.275 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_42 },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_41 },
              { t: this.shape_36 },
              { t: this.shape_17, p: { x: 79.05 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_12, p: { x: 110.275, y: 105.675 } },
              { t: this.shape_19, p: { x: 26.225, y: 131.225 } },
              { t: this.shape_22, p: { x: 36.05, y: 131.225 } },
              { t: this.shape_40 },
              { t: this.shape_39 },
              { t: this.shape_6, p: { x: 63.725 } },
              { t: this.shape_9, p: { x: 74.8 } },
              { t: this.shape_38 },
              { t: this.shape_37, p: { x: 97 } },
              { t: this.shape_1, p: { x: 104.05, y: 130.775 } },
              { t: this.shape, p: { x: 110.725, y: 132.825 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 21.325 } },
              { t: this.shape_22, p: { x: 28.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 35.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 42.675 } },
              { t: this.shape_19, p: { x: 56.925, y: 101.825 } },
              { t: this.shape_63 },
              { t: this.shape_62, p: { x: 76.05, y: 101.375 } },
              { t: this.shape_61, p: { x: 81.3, y: 102.4 } },
              { t: this.shape_15, p: { x: 86.6, y: 101.35 } },
              { t: this.shape_14, p: { x: 93.875, y: 105.575 } },
              { t: this.shape_13, p: { x: 100.75, y: 101.375 } },
              { t: this.shape_32, p: { x: 107.275, y: 105.675 } },
              { t: this.shape_60, p: { x: 16.275, y: 131.2239 } },
              { t: this.shape_59, p: { x: 22.7 } },
              { t: this.shape_58 },
              { t: this.shape_57, p: { x: 38.875 } },
              { t: this.shape_1, p: { x: 45.55, y: 130.775 } },
              { t: this.shape_30, p: { x: 52.225, y: 132.825 } },
              { t: this.shape_56, p: { x: 65.45 } },
              { t: this.shape_55, p: { x: 72.85 } },
              { t: this.shape_54, p: { x: 79.525 } },
              { t: this.shape_53, p: { x: 86.2 } },
              { t: this.shape_52, p: { x: 91.5 } },
              { t: this.shape_51, p: { x: 102.825 } },
              { t: this.shape_12, p: { x: 111.625, y: 135.075 } },
              { t: this.shape_50, p: { x: 24.45, y: 160.625 } },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_27, p: { x: 53.225, y: 160.275 } },
              { t: this.shape_33, p: { x: 60.1, y: 160.175 } },
              { t: this.shape, p: { x: 66.775, y: 162.225 } },
              { t: this.shape_47, p: { x: 80, y: 160.625 } },
              { t: this.shape_46 },
              { t: this.shape_45, p: { x: 94.075 } },
              { t: this.shape_44, p: { x: 100.75 } },
              { t: this.shape_43 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_19, p: { x: 59.925, y: 101.825 } },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_32, p: { x: 110.275, y: 105.675 } },
              { t: this.shape_31, p: { x: 23.4, y: 131.225 } },
              { t: this.shape_30, p: { x: 31.875, y: 132.825 } },
              { t: this.shape_65 },
              { t: this.shape_28, p: { x: 49.275 } },
              { t: this.shape_64 },
              { t: this.shape_12, p: { x: 70.425, y: 135.075 } },
              { t: this.shape_6, p: { x: 83.675 } },
              { t: this.shape_29, p: { x: 94.05 } },
              { t: this.shape, p: { x: 103.175, y: 132.825 } },
              { t: this.shape_24, p: { x: 111.075 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_19, p: { x: 59.925, y: 101.825 } },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_70 },
              { t: this.shape_12, p: { x: 110.275, y: 105.675 } },
              { t: this.shape_50, p: { x: 23.9, y: 131.225 } },
              { t: this.shape_69 },
              { t: this.shape_37, p: { x: 43 } },
              { t: this.shape_27, p: { x: 52.675, y: 130.875 } },
              { t: this.shape_33, p: { x: 59.55, y: 130.775 } },
              { t: this.shape, p: { x: 66.225, y: 132.825 } },
              { t: this.shape_68 },
              { t: this.shape_67 },
              { t: this.shape_57, p: { x: 93.525 } },
              { t: this.shape_55, p: { x: 100.2 } },
              { t: this.shape_66 },
              { t: this.shape_24, p: { x: 112.075 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_41 },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_80 },
              { t: this.shape_79 },
              { t: this.shape_78 },
              { t: this.shape_77, p: { x: 59.125, y: 130.875 } },
              { t: this.shape_55, p: { x: 66.35 } },
              { t: this.shape_76 },
              { t: this.shape_75 },
              { t: this.shape_74, p: { x: 87.675 } },
              { t: this.shape_32, p: { x: 94.725, y: 135.075 } },
              { t: this.shape_19, p: { x: 43.375, y: 160.625 } },
              { t: this.shape, p: { x: 55.075, y: 162.225 } },
              { t: this.shape_73 },
              { t: this.shape_72 },
              { t: this.shape_71 },
              { t: this.shape_12, p: { x: 93.675, y: 164.475 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_41 },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_80 },
              { t: this.shape_79 },
              { t: this.shape_78 },
              { t: this.shape_77, p: { x: 59.125, y: 130.875 } },
              { t: this.shape_55, p: { x: 66.35 } },
              { t: this.shape_76 },
              { t: this.shape_75 },
              { t: this.shape_74, p: { x: 87.675 } },
              { t: this.shape_32, p: { x: 94.725, y: 135.075 } },
              { t: this.shape_19, p: { x: 43.375, y: 160.625 } },
              { t: this.shape, p: { x: 55.075, y: 162.225 } },
              { t: this.shape_73 },
              { t: this.shape_72 },
              { t: this.shape_71 },
              { t: this.shape_12, p: { x: 93.675, y: 164.475 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.325 } },
              { t: this.shape_22, p: { x: 31.7, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.475, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.675 } },
              { t: this.shape_41 },
              { t: this.shape_36 },
              { t: this.shape_1, p: { x: 79.05, y: 101.375 } },
              { t: this.shape_35 },
              { t: this.shape_34, p: { x: 89.6 } },
              { t: this.shape_14, p: { x: 96.875, y: 105.575 } },
              { t: this.shape_33, p: { x: 103.75, y: 101.375 } },
              { t: this.shape_80 },
              { t: this.shape_79 },
              { t: this.shape_78 },
              { t: this.shape_77, p: { x: 59.125, y: 130.875 } },
              { t: this.shape_55, p: { x: 66.35 } },
              { t: this.shape_76 },
              { t: this.shape_75 },
              { t: this.shape_74, p: { x: 87.675 } },
              { t: this.shape_32, p: { x: 94.725, y: 135.075 } },
              { t: this.shape_19, p: { x: 43.375, y: 160.625 } },
              { t: this.shape, p: { x: 55.075, y: 162.225 } },
              { t: this.shape_73 },
              { t: this.shape_72 },
              { t: this.shape_71 },
              { t: this.shape_12, p: { x: 93.675, y: 164.475 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.175 } },
              { t: this.shape_22, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_21, p: { x: 38.325, y: 101.825 } },
              { t: this.shape_20, p: { x: 45.525 } },
              { t: this.shape_91 },
              { t: this.shape_18, p: { x: 65.5 } },
              { t: this.shape_27, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_90 },
              { t: this.shape_89 },
              { t: this.shape_88 },
              { t: this.shape_87 },
              { t: this.shape_86 },
              { t: this.shape_60, p: { x: 29.875, y: 131.2239 } },
              { t: this.shape_47, p: { x: 39.5, y: 131.225 } },
              { t: this.shape_85 },
              { t: this.shape_74, p: { x: 57.375 } },
              { t: this.shape_84 },
              { t: this.shape_83 },
              { t: this.shape_82, p: { x: 92.55, y: 131.225 } },
              { t: this.shape_81, p: { x: 103.15, y: 131.225 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 30.025 } },
              { t: this.shape_22, p: { x: 37.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 44.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 51.375 } },
              { t: this.shape_47, p: { x: 63.8, y: 101.825 } },
              { t: this.shape_15, p: { x: 71.2, y: 101.35 } },
              { t: this.shape_93, p: { x: 77.775 } },
              { t: this.shape_92, p: { x: 84.3 } },
              { t: this.shape_77, p: { x: 91.225, y: 101.475 } },
              { t: this.shape_30, p: { x: 100.525, y: 103.425 } },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9, p: { x: 30.7 } },
              { t: this.shape_8 },
              { t: this.shape_7 },
              { t: this.shape_6, p: { x: 59.525 } },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1, p: { x: 110, y: 130.775 } },
              { t: this.shape, p: { x: 116.675, y: 132.825 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 32.025 } },
              { t: this.shape_22, p: { x: 39.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 46.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 53.375 } },
              { t: this.shape_81, p: { x: 65.8, y: 101.825 } },
              { t: this.shape_15, p: { x: 73.2, y: 101.35 } },
              { t: this.shape_93, p: { x: 79.775 } },
              { t: this.shape_92, p: { x: 86.3 } },
              { t: this.shape_77, p: { x: 93.225, y: 101.475 } },
              { t: this.shape_30, p: { x: 102.525, y: 103.425 } },
              { t: this.shape_19, p: { x: 32.175, y: 131.225 } },
              { t: this.shape_55, p: { x: 41.8 } },
              { t: this.shape_98 },
              { t: this.shape_97 },
              { t: this.shape_96 },
              { t: this.shape_74, p: { x: 70.375 } },
              { t: this.shape_95 },
              { t: this.shape_94 },
              { t: this.shape_13, p: { x: 98.15, y: 130.775 } },
              { t: this.shape, p: { x: 104.825, y: 132.825 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 32.025 } },
              { t: this.shape_22, p: { x: 39.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 46.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 53.375 } },
              { t: this.shape_81, p: { x: 65.8, y: 101.825 } },
              { t: this.shape_15, p: { x: 73.2, y: 101.35 } },
              { t: this.shape_93, p: { x: 79.775 } },
              { t: this.shape_92, p: { x: 86.3 } },
              { t: this.shape_77, p: { x: 93.225, y: 101.475 } },
              { t: this.shape_30, p: { x: 102.525, y: 103.425 } },
              { t: this.shape_19, p: { x: 32.175, y: 131.225 } },
              { t: this.shape_55, p: { x: 41.8 } },
              { t: this.shape_98 },
              { t: this.shape_97 },
              { t: this.shape_96 },
              { t: this.shape_74, p: { x: 70.375 } },
              { t: this.shape_95 },
              { t: this.shape_94 },
              { t: this.shape_13, p: { x: 98.15, y: 130.775 } },
              { t: this.shape, p: { x: 104.825, y: 132.825 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 32.025 } },
              { t: this.shape_22, p: { x: 39.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 46.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 53.375 } },
              { t: this.shape_81, p: { x: 65.8, y: 101.825 } },
              { t: this.shape_106 },
              { t: this.shape_93, p: { x: 79.775 } },
              { t: this.shape_92, p: { x: 86.3 } },
              { t: this.shape_77, p: { x: 93.225, y: 101.475 } },
              { t: this.shape_105 },
              { t: this.shape_26, p: { x: 27.4 } },
              { t: this.shape_74, p: { x: 35.275 } },
              { t: this.shape_104 },
              { t: this.shape_14, p: { x: 47.675, y: 134.975 } },
              { t: this.shape_1, p: { x: 54.55, y: 130.775 } },
              { t: this.shape_30, p: { x: 61.225, y: 132.825 } },
              { t: this.shape_56, p: { x: 74.45 } },
              { t: this.shape_55, p: { x: 81.85 } },
              { t: this.shape_54, p: { x: 88.525 } },
              { t: this.shape_53, p: { x: 95.2 } },
              { t: this.shape_52, p: { x: 100.5 } },
              { t: this.shape_24, p: { x: 107.075 } },
              { t: this.shape_27, p: { x: 39.025, y: 160.275 } },
              { t: this.shape_12, p: { x: 47.825, y: 164.475 } },
              { t: this.shape_60, p: { x: 59.625, y: 160.6239 } },
              { t: this.shape_103, p: { x: 66.05 } },
              { t: this.shape_102 },
              { t: this.shape_45, p: { x: 82.225 } },
              { t: this.shape_33, p: { x: 88.9, y: 160.175 } },
              { t: this.shape, p: { x: 95.575, y: 162.225 } },
              { t: this.shape_47, p: { x: 51.65, y: 190.025 } },
              { t: this.shape_101 },
              { t: this.shape_100 },
              { t: this.shape_15, p: { x: 72.4, y: 189.55 } },
              { t: this.shape_61, p: { x: 77.7, y: 190.6 } },
              { t: this.shape_99, p: { x: 84.275 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 32.025 } },
              { t: this.shape_22, p: { x: 39.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 46.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 53.375 } },
              { t: this.shape_81, p: { x: 65.8, y: 101.825 } },
              { t: this.shape_15, p: { x: 73.2, y: 101.35 } },
              { t: this.shape_93, p: { x: 79.775 } },
              { t: this.shape_92, p: { x: 86.3 } },
              { t: this.shape_77, p: { x: 93.225, y: 101.475 } },
              { t: this.shape_105 },
              { t: this.shape_19, p: { x: 43.375, y: 131.225 } },
              { t: this.shape_116 },
              { t: this.shape_13, p: { x: 62.5, y: 130.775 } },
              { t: this.shape_115 },
              { t: this.shape_53, p: { x: 73.05 } },
              { t: this.shape_14, p: { x: 80.325, y: 134.975 } },
              { t: this.shape_62, p: { x: 87.2, y: 130.775 } },
              { t: this.shape_32, p: { x: 93.725, y: 135.075 } },
              { t: this.shape_60, p: { x: 26.425, y: 160.6239 } },
              { t: this.shape_114 },
              { t: this.shape_113 },
              { t: this.shape_112 },
              { t: this.shape_33, p: { x: 55.7, y: 160.175 } },
              { t: this.shape_30, p: { x: 62.375, y: 162.225 } },
              { t: this.shape_111, p: { x: 75.6 } },
              { t: this.shape_44, p: { x: 83 } },
              { t: this.shape_45, p: { x: 89.675 } },
              { t: this.shape_110 },
              { t: this.shape_109 },
              { t: this.shape_108 },
              { t: this.shape_27, p: { x: 44.525, y: 189.675 } },
              { t: this.shape_12, p: { x: 53.325, y: 193.875 } },
              { t: this.shape_31, p: { x: 65, y: 190.025 } },
              { t: this.shape, p: { x: 73.475, y: 191.625 } },
              { t: this.shape_107 },
              { t: this.shape_99, p: { x: 90.875 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 32.025 } },
              { t: this.shape_22, p: { x: 39.4, y: 101.825 } },
              { t: this.shape_21, p: { x: 46.175, y: 101.825 } },
              { t: this.shape_20, p: { x: 53.375 } },
              { t: this.shape_81, p: { x: 65.8, y: 101.825 } },
              { t: this.shape_15, p: { x: 73.2, y: 101.35 } },
              { t: this.shape_93, p: { x: 79.775 } },
              { t: this.shape_92, p: { x: 86.3 } },
              { t: this.shape_77, p: { x: 93.225, y: 101.475 } },
              { t: this.shape_30, p: { x: 102.525, y: 103.425 } },
              { t: this.shape_19, p: { x: 24.975, y: 131.225 } },
              { t: this.shape_123 },
              { t: this.shape_62, p: { x: 44.1, y: 130.775 } },
              { t: this.shape_122 },
              { t: this.shape_59, p: { x: 54.65 } },
              { t: this.shape_121 },
              { t: this.shape_55, p: { x: 73.3 } },
              { t: this.shape_54, p: { x: 79.975 } },
              { t: this.shape_53, p: { x: 86.65 } },
              { t: this.shape_120 },
              { t: this.shape_51, p: { x: 103.275 } },
              { t: this.shape_12, p: { x: 112.075, y: 135.075 } },
              { t: this.shape_111, p: { x: 27.45 } },
              { t: this.shape_119 },
              { t: this.shape_118 },
              { t: this.shape_27, p: { x: 56.225, y: 160.275 } },
              { t: this.shape_1, p: { x: 63.1, y: 160.175 } },
              { t: this.shape, p: { x: 69.775, y: 162.225 } },
              { t: this.shape_82, p: { x: 83, y: 160.625 } },
              { t: this.shape_44, p: { x: 90.4 } },
              { t: this.shape_45, p: { x: 97.075 } },
              { t: this.shape_103, p: { x: 103.75 } },
              { t: this.shape_117 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 21.425 } },
              { t: this.shape_22, p: { x: 28.8, y: 101.825 } },
              { t: this.shape_129 },
              { t: this.shape_20, p: { x: 42.775 } },
              { t: this.shape_82, p: { x: 55.2, y: 101.825 } },
              { t: this.shape_34, p: { x: 62.6 } },
              { t: this.shape_93, p: { x: 69.175 } },
              { t: this.shape_15, p: { x: 75.7, y: 101.35 } },
              { t: this.shape_77, p: { x: 82.625, y: 101.475 } },
              { t: this.shape, p: { x: 91.925, y: 103.425 } },
              { t: this.shape_128 },
              { t: this.shape_127 },
              { t: this.shape_21, p: { x: 52.575, y: 131.225 } },
              { t: this.shape_126 },
              { t: this.shape_125 },
              { t: this.shape_124 },
              { t: this.shape_24, p: { x: 82.125 } },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(1, 85.3, 128, 119.60000000000001);

  (lib.over = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#006666').ss(1, 1, 1).p('ApmizITNAAIAAFnIzNAAg');
    this.shape.setTransform(60.5, 16);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#006666').s().p('ApmC0IAAlnITNAAIAAFng');
    this.shape_1.setTransform(60.5, 16);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.over,
    new cjs.Rectangle(-2, -3, 125, 38),
    null,
  );

  (lib.OperationButtons = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

    // icon
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AAxgwIBqAAAiaAxIAAhhIBqAAIAAhqIBhAAAgwCbIAAhq');
    this.shape.setTransform(-0.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('AAxiaIAABqACbgwIAABhIhqAAIAABqIhhAAAgwAxIhqAA');
    this.shape_1.setTransform(-0.05, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AgvCbIAAhqIhrAAIAAhhIBrAAIAAhqIBgAAIAABqIBqAAIAABhIhqAAIAABqg');
    this.shape_2.setTransform(-0.05, 0);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f().s('#666666').ss(1, 1, 1).p('AiaAxIAAhhIE1AA');
    this.shape_3.setTransform(-0.05, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f().s('#CCCCCC').ss(1, 1, 1).p('ACbgwIAABhIk1AA');
    this.shape_4.setTransform(-0.05, 0.025);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AiaAxIAAhhIE1AAIAABhg');
    this.shape_5.setTransform(-0.05, 0.025);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('ACQApIhFBFIhLhLIhKBLIhFhFAhEgiIhLhLACQhtIhLBL');
    this.shape_6.setTransform(0.05, 3.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AiPgoIBFhFIBKBLIBLhLIBFBFAiPBuIBLhMABFAiIBLBM');
    this.shape_7.setTransform(0.05, -3.4);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AAABFIhKBLIhFhFIBLhLIhLhKIBFhFIBKBLIBLhLIBFBFIhLBKIBLBLIhFBFg');
    this.shape_8.setTransform(0.05, 0.05);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p(
        'AgZhPQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABAMAHAgZCUQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABALAGAiaA1IAAhhIE1AA',
      );
    this.shape_9.setTransform(0, -0.436);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p(
        'AAeiQQADAFACAFQADAKgCAKQgCAKgFAHQgDAEgFAEQgNAJgPgDQgHgBgFgDAAdBTQAKAOgDAQQgCAPgNAKQgNAJgPgDQgHgBgFgDACbg4IAABhIk1AA',
      );
    this.shape_10.setTransform(0, 0.761);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p(
        'AgGCYIgNgEIgFgFIgHgHQgJgNACgPQADgQAOgJQAMgJAPACQAIABAKAHIAFAGQAKAPgDAQQgCAPgNAJQgKAHgLAAIgGAAgAiaAwIAAhgIE1AAIAABggAgGhLQgIgCgFgDIgFgEIgHgHQgJgNACgQQADgPAOgJQAMgKAPADQAIABALAIIAFAFIAFAKQADAKgCAKQgCAKgFAHQgDAFgFADQgLAHgKAAIgGAAg',
      );
    this.shape_11.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_8 },
              { t: this.shape_7 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // color
    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], -1.9, -8.5, 0, -1.9, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gRhmQgThlA7hVQA7hUBngSQBkgRBVA7QBVA7ASBmQASBlg8BUQg7BUhlATQgYAEgWAAQhLAAhBgug',
      );
    this.shape_12.setTransform(-0.0061, 0.0189);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .rf(['#1BB448', '#265945'], [0, 1], -1.9, -8.4, 0, -1.9, -8.4, 40)
      .s()
      .p(
        'AiODNQhVg8gShmQgShlA7hUQA8hUBmgTQBkgRBVA7QBUA7ATBmQASBlg8BUQg7BVhmASQgXAEgWAAQhLAAhBgtg',
      );
    this.shape_13.setTransform(0.0146, -0.0135);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], -1.9, -8.6, 0, -1.9, -8.6, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA7hUQA8hWBmgRQBkgSBVA8QBUA7ATBmQARBlg7BUQg8BVhlASQgYAEgWAAQhLAAhAgug',
      );
    this.shape_14.setTransform(0.0045, 0);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .rf(['#FF0000', '#990000'], [0, 1], -1.8, -8.5, 0, -1.8, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA8hVQA7hUBmgSQBkgSBVA8QBUA7ATBmQASBlg8BUQg7BUhlATQgYAEgVAAQhMAAhBgug',
      );
    this.shape_15.setTransform(-0.0102, 0.0013);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_12 }] })
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .wait(1),
    );

    // shine
    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .lf(
        ['rgba(255,255,255,0.502)', 'rgba(255,255,255,0)'],
        [0, 0.682],
        0,
        -19.1,
        0,
        19.2,
      )
      .s()
      .p(
        'AiHCHQg4g3AAhQQAAhPA4g4QA5g3BOAAQBPAAA5A3QA4A4AABPQAABQg4A3Qg5A4hPAAQhOAAg5g4g',
      );
    this.shape_16.setTransform(0.15, -2.3);

    this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-25, -25, 50, 50);

  (lib.Examples = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };
    this.frame_17 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1)
        .call(this.frame_17)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 0, 0);

  (lib.eq = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };
    this.frame_13 = function () {
      this.stop();
    };
    this.frame_14 = function () {
      this.stop();
    };
    this.frame_15 = function () {
      this.stop();
    };
    this.frame_16 = function () {
      this.stop();
    };
    this.frame_17 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1)
        .call(this.frame_13)
        .wait(1)
        .call(this.frame_14)
        .wait(1)
        .call(this.frame_15)
        .wait(1)
        .call(this.frame_16)
        .wait(1)
        .call(this.frame_17)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 0, 0);

  (lib.blocker = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#CCCCCC').s().p('AuDK8IAA13IcHAAIAAV3g');
    this.shape.setTransform(90, 70);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.blocker,
    new cjs.Rectangle(0, 0, 180, 140),
    null,
  );

  (lib.Scoreboard_progressMeter_fill = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFF00').s().p('AvnCWIAAkrIfPAAIAAErg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter_fill,
    new cjs.Rectangle(0, -15, 200, 30),
    null,
  );

  (lib.Scoreboard_changeRoundBtn = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape.setTransform(19.525, 9.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_1.setTransform(12.325, 8.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_2.setTransform(4.975, 9.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_3.setTransform(-2.775, 9.9);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_4.setTransform(-10.3, 9.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_5.setTransform(-17.775, 8.75);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_6.setTransform(19.025, -4.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_7.setTransform(11.425, -3.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_8.setTransform(4.075, -4.775);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_9.setTransform(-3.625, -4.675);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_10.setTransform(-10.825, -5.95);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_11.setTransform(-18.7, -5.775);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape_12.setTransform(19.525, 9.825);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_13.setTransform(12.325, 8.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_14.setTransform(4.975, 9.725);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_15.setTransform(-2.775, 9.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_16.setTransform(-10.3, 9.8);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_17.setTransform(-17.775, 8.75);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_18.setTransform(19.025, -4.7);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_19.setTransform(11.425, -3.525);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_20.setTransform(4.075, -4.775);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_21.setTransform(-3.625, -4.675);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_22.setTransform(-10.825, -5.95);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_23.setTransform(-18.7, -5.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // Layer 2
    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#000000').s().p('Aj3ClIAAlJIHuAAIAAFJg');
    this.shape_24.setTransform(-0.05, 2.1);

    this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-24.8, -15.4, 49.5, 34);

  (lib.redX = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#FF0000')
      .ss(5, 0, 0, 3)
      .p('ACWCWIiWiWIiVCWAAAAAICWiVAiViVICVCV');
    this.shape.setTransform(0, 0.0029);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -17.5, 35, 35);

  (lib.roundBtnshine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        22.5,
        0,
        -22.5,
      )
      .s()
      .p('AiuDhQgyAAAAgyIAAldQAAgyAyAAIFdAAQAyAAAAAyIAAFdQAAAygyAAg');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -22.5, 45, 45);

  (lib.roundBtnhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape.setTransform(0, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_1.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtnhover,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.GameFrame_veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg/RAvqMAAAhfTMB+jAAAMAAABfTg');
    this.shape.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameFrame_veil,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.EndScreenbuttonhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonhover,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreenbuttonbg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5645DA')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonbg,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.ValueTextBlack_fields = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // line
    this.line = new lib.ValueTextBlack_line();
    this.line.name = 'line';

    this.timeline.addTween(cjs.Tween.get(this.line).wait(1));

    // denominator
    this.denominator = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.denominator.name = 'denominator';
    this.denominator.textAlign = 'center';
    this.denominator.lineHeight = 23;
    this.denominator.lineWidth = 76;
    this.denominator.parent = this;
    this.denominator.setTransform(-1.35, -10.6);

    this.timeline.addTween(cjs.Tween.get(this.denominator).wait(1));

    // numerator
    this.numerator = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.numerator.name = 'numerator';
    this.numerator.textAlign = 'center';
    this.numerator.lineHeight = 23;
    this.numerator.lineWidth = 78;
    this.numerator.parent = this;
    this.numerator.setTransform(-1.6, -29.05);

    this.timeline.addTween(cjs.Tween.get(this.numerator).wait(1));

    // extraTinyText
    this.extraTinyText = new cjs.Text('1', "bold 18px 'Open Sans Condensed'");
    this.extraTinyText.name = 'extraTinyText';
    this.extraTinyText.textAlign = 'center';
    this.extraTinyText.lineHeight = 26;
    this.extraTinyText.lineWidth = 81;
    this.extraTinyText.parent = this;
    this.extraTinyText.setTransform(-2.5, -12.1);

    this.timeline.addTween(cjs.Tween.get(this.extraTinyText).wait(1));

    // tinyText
    this.tinyText = new cjs.Text('1', "bold 22px 'Open Sans Condensed'");
    this.tinyText.name = 'tinyText';
    this.tinyText.textAlign = 'center';
    this.tinyText.lineHeight = 32;
    this.tinyText.lineWidth = 81;
    this.tinyText.parent = this;
    this.tinyText.setTransform(-2.5, -15.2);

    this.timeline.addTween(cjs.Tween.get(this.tinyText).wait(1));

    // smallText
    this.smallText = new cjs.Text('1', "bold 24px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 35;
    this.smallText.lineWidth = 81;
    this.smallText.parent = this;
    this.smallText.setTransform(-2.5, -18.7);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    // largeText
    this.largeText = new cjs.Text('1', "bold 26px 'Open Sans Condensed'");
    this.largeText.name = 'largeText';
    this.largeText.textAlign = 'center';
    this.largeText.lineHeight = 37;
    this.largeText.lineWidth = 81;
    this.largeText.parent = this;
    this.largeText.setTransform(-2.5, -22.1);

    this.timeline.addTween(cjs.Tween.get(this.largeText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueTextBlack_fields,
    new cjs.Rectangle(-45, -31, 85, 51.8),
    null,
  );

  (lib.comsuntexsymbolsValueTextBlack = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // fields
    this.fields = new lib.ValueTextBlack_fields();
    this.fields.name = 'fields';
    this.fields.setTransform(2.25, 0.9);

    this.timeline.addTween(cjs.Tween.get(this.fields).wait(1));

    // glow
    this.textGlow = new lib.ValueText_glow();
    this.textGlow.name = 'textGlow';

    this.timeline.addTween(cjs.Tween.get(this.textGlow).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueTextBlack,
    new cjs.Rectangle(-42.7, -30.1, 85, 60.1),
    null,
  );

  (lib.comsuntexsymbolsPositiveFeedback = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.text = new lib.PostitiveFeedback_text();
    this.text.name = 'text';
    this.text.setTransform(0.7, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

    // bg
    this.bg = new lib.PostivieFeedback_bg();
    this.bg.name = 'bg';
    this.bg.setTransform(-4, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        ['#FFFFFF', 'rgba(255,255,255,0)'],
        [0.749, 1],
        -0.1,
        -0.1,
        0,
        -0.1,
        -0.1,
        47.4,
      )
      .s()
      .p(
        'AvCFUQmPiMAAjIQAAjGGPiOQGPiNIzAAQI0AAGOCNQGPCOABDGQgBDImPCMQmOCOo0AAQozAAmPiOg',
      );
    this.shape.setTransform(-0.2, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsPositiveFeedback,
    new cjs.Rectangle(-136.3, -48.2, 272.3, 96.4),
    null,
  );

  (lib.textMovieClip = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1),
    );

    // Layer 1
    this.textb = new lib.comsuntexsymbolsValueTextBlack();
    this.textb.name = 'textb';
    this.textb.setTransform(-0.05, 0.95, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.textb).wait(5));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(-0.2, 1.95);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape_1.setTransform(-0.2, 1.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_2.setTransform(-1.8, 1.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_3.setTransform(-1.8, 1.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#DCF3A8')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_4.setTransform(-1.8, 1.4);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_5.setTransform(-1.8, 1.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-52.1, -29.2, 103.6, 60.2);

  (lib.start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { button: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape.setTransform(132.825, -102.975);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKA1IgZgpIAAApIgdAAIAAhpIAsAAQAIAAAGACQAGACAFAFQAJAKAAAOQAAAHgCAGQgDAGgFADQgEAFgJACIAhArgAgPgFIAEAAQAJAAACgCIAEgFIABgGIgBgGIgEgEQgCgDgJAAIgEAAg',
      );
    this.shape_1.setTransform(124.55, -102.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AAaA1IgHgSIglAAIgHASIgeAAIAphpIAeAAIAoBpgAgKAOIAWAAIgMghg');
    this.shape_2.setTransform(113.325, -102.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape_3.setTransform(104.525, -102.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmArIAMgWQAMALAMAAQAGAAAEgDQACgDAAgEQAAgFgDgCQgEgCgIgDQgQgFgFgEQgIgGAAgPQAAgQALgKQAKgJAOAAQASAAAQAIIgLAWQgJgHgJAAQgGAAgCADQgDADAAADQAAAFAGADIAMAEQAOAEAGAHQAGAGAAAMQAAAVgNAJQgMAIgPAAQgUAAgRgNg',
      );
    this.shape_4.setTransform(96.175, -102.95);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#5877CA').s().p('AluCeIAAk6ILdAAIAAE6g');
    this.shape_5.setTransform(115.75, -103.25);

    this.clockDisplay = new lib.comsuntexsymbolsValueTextBlack();
    this.clockDisplay.name = 'clockDisplay';
    this.clockDisplay.setTransform(
      115.65,
      -102.5,
      1.2185,
      1.25,
      0,
      0,
      0,
      -0.4,
      0,
    );
    this.clockDisplay.alpha = 0.1484;

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#5877F9').s().p('Al9CsIAAlXIL8AAIAAFXg');
    this.shape_6.setTransform(117.25, -101.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to({ state: [{ t: this.shape_6 }, { t: this.clockDisplay }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(64, -140.1, 103.6, 75.1);

  (lib.rules = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.examples = new lib.Examples();
    this.examples.name = 'examples';
    this.examples.setTransform(64.5, 259.4, 1, 1, 0, 0, 0, 48.5, 16.9);

    this.ruleTxt = new lib.ruletext();
    this.ruleTxt.name = 'ruleTxt';
    this.ruleTxt.setTransform(65.5, 162.5, 1, 1, 0, 0, 0, 0.5, 0.5);

    this.ruleHdr = new lib.ruleheader();
    this.ruleHdr.name = 'ruleHdr';
    this.ruleHdr.setTransform(67, 107.5, 1, 1, 0, 0, 0, 67, 117.2);

    this.equatn = new lib.eq();
    this.equatn.name = 'equatn';
    this.equatn.setTransform(63.5, 299.2, 1, 1, 0, 0, 0, 63.5, 17.5);

    this.opBtn1 = new lib.OperationButtons();
    this.opBtn1.name = 'opBtn1';
    this.opBtn1.setTransform(65.8, 30.2, 1.5, 1.5, 0, 0, 0, 0, -0.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.opBtn1 },
            { t: this.equatn },
            { t: this.ruleHdr },
            { t: this.ruleTxt },
            { t: this.examples },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.rules,
    new cjs.Rectangle(1, -7, 128, 143.4),
    null,
  );

  (lib.numberPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // Layer 3
    this.ro = new lib.over();
    this.ro.name = 'ro';
    this.ro.setTransform(30.55, 3.7, 0.4065, 0.5153, 0, 0, 0, 60.5, 16.1);

    this.timeline.addTween(cjs.Tween.get(this.ro).wait(3));

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(30, 52.05, 1, 1, 0, 0, 0, 0, 8);

    this.text3 = new lib.comsuntexsymbolsValueTextBlack();
    this.text3.name = 'text3';
    this.text3.setTransform(29.95, 3.85, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.text3 }, { t: this.t }] })
        .wait(3),
    );

    // tile
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#BBE42E')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape.setTransform(27.5, 22);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_1.setTransform(27.5, 22);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#7AA8F9')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_2.setTransform(27.5, 22);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -28, 104, 103);

  (lib.mPiece = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(0, 9.05, 1, 1, 0, 0, 0, 0, 8);

    this.timeline.addTween(cjs.Tween.get(this.t).wait(2));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(0.8, -0.05);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_1.setTransform(-1.8, 1.4);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_2.setTransform(-1.8, 1.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-52.1, -28.1, 103.6, 60.1);

  (lib.BigBoard = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.row5col3 = new lib.numberPanel();
    this.row5col3.name = 'row5col3';
    this.row5col3.setTransform(655.2, 914.6, 1.8199, 1.7668, 0, 0, 0, 17.2, 13);

    this.row5col5 = new lib.numberPanel();
    this.row5col5.name = 'row5col5';
    this.row5col5.setTransform(
      1031.05,
      915.6,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row5col4 = new lib.numberPanel();
    this.row5col4.name = 'row5col4';
    this.row5col4.setTransform(843.1, 914.6, 1.8199, 1.7673, 0, 0, 0, 17.1, 13);

    this.row4col5 = new lib.numberPanel();
    this.row4col5.name = 'row4col5';
    this.row4col5.setTransform(
      1031.05,
      734.6,
      1.8198,
      1.7668,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row4col4 = new lib.numberPanel();
    this.row4col4.name = 'row4col4';
    this.row4col4.setTransform(843.1, 734.6, 1.8198, 1.7673, 0, 0, 0, 17.1, 13);

    this.row4col3 = new lib.numberPanel();
    this.row4col3.name = 'row4col3';
    this.row4col3.setTransform(
      655.2,
      734.8,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row3col5 = new lib.numberPanel();
    this.row3col5.name = 'row3col5';
    this.row3col5.setTransform(1030.05, 554, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row3col4 = new lib.numberPanel();
    this.row3col4.name = 'row3col4';
    this.row3col4.setTransform(843.1, 554, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row3col3 = new lib.numberPanel();
    this.row3col3.name = 'row3col3';
    this.row3col3.setTransform(
      655.2,
      553.85,
      1.82,
      1.7668,
      0,
      0,
      0,
      17.2,
      12.9,
    );

    this.row2col3 = new lib.numberPanel();
    this.row2col3.name = 'row2col3';
    this.row2col3.setTransform(
      654.2,
      373.65,
      1.8199,
      1.7668,
      0,
      0,
      0,
      17.2,
      13,
    );

    this.row2col5 = new lib.numberPanel();
    this.row2col5.name = 'row2col5';
    this.row2col5.setTransform(
      1030.05,
      374.65,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row2col4 = new lib.numberPanel();
    this.row2col4.name = 'row2col4';
    this.row2col4.setTransform(
      842.1,
      373.65,
      1.8199,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col5 = new lib.numberPanel();
    this.row1col5.name = 'row1col5';
    this.row1col5.setTransform(
      1030.05,
      193.65,
      1.8198,
      1.7668,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col4 = new lib.numberPanel();
    this.row1col4.name = 'row1col4';
    this.row1col4.setTransform(
      842.1,
      193.65,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col3 = new lib.numberPanel();
    this.row1col3.name = 'row1col3';
    this.row1col3.setTransform(
      654.2,
      193.85,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row0col5 = new lib.numberPanel();
    this.row0col5.name = 'row0col5';
    this.row0col5.setTransform(1030.05, 13.05, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col4 = new lib.numberPanel();
    this.row0col4.name = 'row0col4';
    this.row0col4.setTransform(842.1, 13.05, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col3 = new lib.numberPanel();
    this.row0col3.name = 'row0col3';
    this.row0col3.setTransform(654.2, 12.9, 1.82, 1.7668, 0, 0, 0, 17.2, 12.9);

    this.row5col0 = new lib.numberPanel();
    this.row5col0.name = 'row5col0';
    this.row5col0.setTransform(92.2, 914.65, 1.8199, 1.7668, 0, 0, 0, 17.2, 13);

    this.row5col2 = new lib.numberPanel();
    this.row5col2.name = 'row5col2';
    this.row5col2.setTransform(
      468.05,
      915.65,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row5col1 = new lib.numberPanel();
    this.row5col1.name = 'row5col1';
    this.row5col1.setTransform(
      280.1,
      914.65,
      1.8199,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row4col2 = new lib.numberPanel();
    this.row4col2.name = 'row4col2';
    this.row4col2.setTransform(
      468.05,
      734.65,
      1.8198,
      1.7668,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row4col1 = new lib.numberPanel();
    this.row4col1.name = 'row4col1';
    this.row4col1.setTransform(
      280.1,
      734.65,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row4col0 = new lib.numberPanel();
    this.row4col0.name = 'row4col0';
    this.row4col0.setTransform(
      92.2,
      734.85,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row3col2 = new lib.numberPanel();
    this.row3col2.name = 'row3col2';
    this.row3col2.setTransform(468.05, 554.05, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row3col1 = new lib.numberPanel();
    this.row3col1.name = 'row3col1';
    this.row3col1.setTransform(280.1, 554.05, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row3col0 = new lib.numberPanel();
    this.row3col0.name = 'row3col0';
    this.row3col0.setTransform(92.2, 553.9, 1.82, 1.7668, 0, 0, 0, 17.2, 12.9);

    this.row2col0 = new lib.numberPanel();
    this.row2col0.name = 'row2col0';
    this.row2col0.setTransform(90.25, 373.1, 1.8199, 1.7668, 0, 0, 0, 17.2, 13);

    this.row2col2 = new lib.numberPanel();
    this.row2col2.name = 'row2col2';
    this.row2col2.setTransform(466.1, 374.1, 1.8198, 1.7673, 0, 0, 0, 17.1, 13);

    this.row2col1 = new lib.numberPanel();
    this.row2col1.name = 'row2col1';
    this.row2col1.setTransform(
      278.15,
      373.1,
      1.8199,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col2 = new lib.numberPanel();
    this.row1col2.name = 'row1col2';
    this.row1col2.setTransform(466.1, 193.1, 1.8198, 1.7668, 0, 0, 0, 17.1, 13);

    this.row1col1 = new lib.numberPanel();
    this.row1col1.name = 'row1col1';
    this.row1col1.setTransform(
      278.15,
      193.1,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col0 = new lib.numberPanel();
    this.row1col0.name = 'row1col0';
    this.row1col0.setTransform(
      90.25,
      193.3,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row0col2 = new lib.numberPanel();
    this.row0col2.name = 'row0col2';
    this.row0col2.setTransform(466.1, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col1 = new lib.numberPanel();
    this.row0col1.name = 'row0col1';
    this.row0col1.setTransform(278.15, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col0 = new lib.numberPanel();
    this.row0col0.name = 'row0col0';
    this.row0col0.setTransform(90.25, 12.35, 1.82, 1.7668, 0, 0, 0, 17.2, 12.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.row0col0 },
            { t: this.row0col1 },
            { t: this.row0col2 },
            { t: this.row1col0 },
            { t: this.row1col1 },
            { t: this.row1col2 },
            { t: this.row2col1 },
            { t: this.row2col2 },
            { t: this.row2col0 },
            { t: this.row3col0 },
            { t: this.row3col1 },
            { t: this.row3col2 },
            { t: this.row4col0 },
            { t: this.row4col1 },
            { t: this.row4col2 },
            { t: this.row5col1 },
            { t: this.row5col2 },
            { t: this.row5col0 },
            { t: this.row0col3 },
            { t: this.row0col4 },
            { t: this.row0col5 },
            { t: this.row1col3 },
            { t: this.row1col4 },
            { t: this.row1col5 },
            { t: this.row2col4 },
            { t: this.row2col5 },
            { t: this.row2col3 },
            { t: this.row3col3 },
            { t: this.row3col4 },
            { t: this.row3col5 },
            { t: this.row4col3 },
            { t: this.row4col4 },
            { t: this.row4col5 },
            { t: this.row5col4 },
            { t: this.row5col5 },
            { t: this.row5col3 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.BigBoard,
    new cjs.Rectangle(18, -59.9, 1130.3, 1085.1000000000001),
    null,
  );

  (lib.Scoreboard_progressMeter = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#003366').ss(2, 1, 1).p('AvniVIfPAAIAAErI/PAAg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // fill
    this.percentCompleteTxt = new cjs.Text('', "bold 14px 'Roboto'", '#FFFFFF');
    this.percentCompleteTxt.name = 'percentCompleteTxt';
    this.percentCompleteTxt.lineHeight = 19;
    this.percentCompleteTxt.lineWidth = 28;
    this.percentCompleteTxt.parent = this;
    this.percentCompleteTxt.setTransform(205, -9.25, 1, 1.0024);

    this.progressMeterFill = new lib.Scoreboard_progressMeter_fill();
    this.progressMeterFill.name = 'progressMeterFill';
    this.progressMeterFill.setTransform(100, 0, 1, 1, 0, 0, 0, 100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.progressMeterFill },
            { t: this.percentCompleteTxt },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003366')
      .ss(2, 1, 1)
      .p('AvniVIfPAAIAAErI/PAAg');
    this.shape_1.setTransform(100, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(0,51,102,0.047)')
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape_2.setTransform(100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter,
    new cjs.Rectangle(-1, -16, 235.9, 32),
    null,
  );

  (lib.Scoreboard_muteBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape.setTransform(11.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#666666')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape_1.setTransform(11.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // Layer_1
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_2.setTransform(-8.225, 0.025);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(4));

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.Scoreboard_musicBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_7
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AieAZQAAgbAfgWIAMAFIgEADQgWARAAAYQAAAbAaATIgMAEQgfgWAAgcgAB0AUQAagSAAgaQAAgYgWgSIgEgEIAMgEQAfAWAAAcQAAAbgfAWg',
      );
    this.shape.setTransform(-0.475, 7.5);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(3).to({ _off: false }, 0).wait(1),
    );

    // Layer_5
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_1.setTransform(-1.05, -1.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_2.setTransform(-1.05, -1.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }] })
        .to({ state: [{ t: this.shape_2 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.ProgressPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.correctTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.correctTxt.name = 'correctTxt';
    this.correctTxt.lineHeight = 21;
    this.correctTxt.lineWidth = 28;
    this.correctTxt.parent = this;
    this.correctTxt.setTransform(273.65, -8.9, 1, 1.0024);

    this.roundTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.roundTxt.name = 'roundTxt';
    this.roundTxt.lineHeight = 21;
    this.roundTxt.lineWidth = 20;
    this.roundTxt.parent = this;
    this.roundTxt.setTransform(68.05, -8.2856, 1, 1.0024);

    this.gameTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.gameTxt.name = 'gameTxt';
    this.gameTxt.lineHeight = 21;
    this.gameTxt.lineWidth = 25;
    this.gameTxt.parent = this;
    this.gameTxt.setTransform(156.25, -8.3, 1, 1.0024);

    this.correctLbl = new cjs.Text('Correct:', "bold 15px 'Roboto'", '#FFFFFF');
    this.correctLbl.name = 'correctLbl';
    this.correctLbl.lineHeight = 20;
    this.correctLbl.lineWidth = 57;
    this.correctLbl.parent = this;
    this.correctLbl.setTransform(203.9, -8.45, 1.0021, 0.9976);

    this.bonusTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.bonusTxt.name = 'bonusTxt';
    this.bonusTxt.lineHeight = 21;
    this.bonusTxt.lineWidth = 48;
    this.bonusTxt.parent = this;
    this.bonusTxt.setTransform(537.5, -9.3, 1, 1.0024);

    this.progressMeterMc = new lib.Scoreboard_progressMeter();
    this.progressMeterMc.name = 'progressMeterMc';
    this.progressMeterMc.setTransform(290.15, -0.7, 1, 1, 0, 0, 0, 100, -0.5);

    this.bonusLbl = new cjs.Text(
      'Bonus \nStickers:  ',
      "bold 12px 'Roboto'",
      '#FFFFFF',
    );
    this.bonusLbl.name = 'bonusLbl';
    this.bonusLbl.textAlign = 'center';
    this.bonusLbl.lineHeight = 12;
    this.bonusLbl.lineWidth = 68;
    this.bonusLbl.parent = this;
    this.bonusLbl.setTransform(493.55, -13.2, 1.0014, 0.9976);

    this.gameLbl = new cjs.Text('GAME:  ', "bold 14px 'Roboto'", '#FFFFFF');
    this.gameLbl.name = 'gameLbl';
    this.gameLbl.lineHeight = 19;
    this.gameLbl.lineWidth = 45;
    this.gameLbl.parent = this;
    this.gameLbl.setTransform(98.5, -7.45, 1.0021, 0.9976);

    this.roundLbl = new cjs.Text('ROUND:', "bold 14px 'Roboto'", '#FFFFFF');
    this.roundLbl.name = 'roundLbl';
    this.roundLbl.lineHeight = 19;
    this.roundLbl.lineWidth = 54;
    this.roundLbl.parent = this;
    this.roundLbl.setTransform(1, -7.45, 1.0021, 0.9976);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.roundLbl },
            { t: this.gameLbl },
            { t: this.bonusLbl },
            { t: this.progressMeterMc },
            { t: this.bonusTxt },
            { t: this.correctLbl },
            { t: this.gameTxt },
            { t: this.roundTxt },
            { t: this.correctTxt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ProgressPanel,
    new cjs.Rectangle(-1, -16.2, 588, 32),
    null,
  );

  (lib.roundBtn4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAjCSIgVAAIAAgwIAAgUIh3AAIgUAAIAAg3ICHioIBMAAIAAAUIAACWIAVAAIATAAIAAAUIAAAhIgoAAIAABEgAhFAZIAkAAIAvAAIAAg8IAAgtg',
      );
    this.shape.setTransform(-0.15, -0.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AAPCSIAAgUIAzAAIAAhEIAoAAIAAghIAUAAIAAA1IgnAAIAABEgAh9BOIAAgUIB4AAIAAAUgABCAFIAAiWIAVAAIAACWgAhZAFIBUhpIAAAtIgwA8g',
      );
    this.shape_1.setTransform(1.85, 1.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#FF0000', '#990000'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn4,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhICQQgagGgQgHIAMADQAaAFAkAAQAgAAAVgGQAWgHARgMQAQgNAJgSQAIgRAAgVQAAgSgGgLQgGgLgJgHIgKgHQAJABAKAEQAMAEAJAHQAJAIAGALQAGALAAASQAAAVgIARQgJASgQANQgRAMgWAHQgWAGgfAAQgkAAgagFgAArgOQgLgEgKgBIAAgDQAZgFAPgTQAPgUAAgYQAAgSgIgOQgIgNgQgKIgFgDIABAAQAVAFANAIQAQAKAIANQAIAOAAASQAAAYgPAUQgPATgZAFIAAACIgJgEgAhqhHIAAgWIATgGQAWgHASAAIASABQAKACAIADIAHAFIgNgBQgSAAgWAHQgVAGgUAMg',
      );
    this.shape.setTransform(2.825, 0.6875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AgnAgIgRgHIAAgBIAHAAQAKAGANAFIgNgDgAA0gYIgZAAIgQAAIAAgKIALAAQANAAAKADQAHACAFAFIgFAAg',
      );
    this.shape_1.setTransform(-2.9375, 4.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhICSIgMgDQgSgFgMgFIAAhAIAIAAQAKAGAMAFIASAHIAMADQAQAFAPAAQALAAAMgCQANgCAKgGQAHgGAEgHQAEgGAAgOQAAgMgFgHIgEgDQgFgFgHgCQgJgDgNAAIgLAAIgOAAIgQAAIAAgzIARAAIAbgBQAKgBAJgEQAIgEAEgGQAFgGAAgMQAAgJgFgFIgEgEIgHgEQgIgEgKgCIgRAAQgSAAgWAGIgTAGQgLAFgLAHIgIAAIAAg/QARgGAbgHQAcgFAcAAQAaAAAVAEQARAEAMAGIAFADQAQAKAIANQAIAOAAATQAAAXgPAUQgPATgZAFIAAADQAKABALAEIAJADIACABIAKAHQAJAJAGALQAGAKAAATQAAAUgIASQgJARgQANQgRANgWAGQgWAGgfAAQgkABgagGg',
      );
    this.shape_2.setTransform(-0.175, -0.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_4.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn3,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhxCLIAAgUIDPAAIAAgkIAUAAIAAA4gAgjA/IAZgUQARgNASgQQAcgaAOgZQAOgZAAgbQAAgdgNgUIAEAEQAdAXAAAqQAAAcgOAYQgOAYgcAaQgRARgSANgAhphKIAAgcQALgGAMgFQATgHASAAQAYgBANALQAHAGACAIQgKgFgQAAQgSABgTAHQgUAIgRALg',
      );
    this.shape.setTransform(2.625, 2.15);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdCUIgUAAIAAgwQAagTAagVQAbgVAPgQQAXgXAKgQQAKgRAAgQQAAgKgDgHQgDgIgHgGQgMgLgYAAQgSAAgTAIQgMAEgLAGIgOAJIgGAAIAAhBQANgGAcgGQAagGAcAAQA1AAAdAXQAJAHAHAJQANAUAAAdQAAAbgOAZQgOAYgcAaQgSARgSANIgYAUIAtAAIBUAAIAAAUIAAAjg',
      );
    this.shape_1.setTransform(0.625, -0.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#1BB448', '#265945'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn2,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhgCSIAAgUICtAAIAAgfIAUAAIAAAzgAARBLIAAjcIAUAAIAADcgAhgg6IAAgUIApAAIAAAUg',
      );
    this.shape.setTransform(1.5, 1.425);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhMCSIgUAAIAAgzIA9AAIAAiFIAAgUIgpAAIgUAAIAAgvQAOAAANgCQANgCAJgEQAJgFAFgHQAGgIABgMIA/AAIAAAUIAADcIAUAAIAoAAIAAAUIAAAfg',
      );
    this.shape_1.setTransform(-0.5, -0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn1,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.nextBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOBZIgNgFIgNgGQgFgDgEgGIAPgUQAGAGAHAEQAIAEAJAAQANAAAIgHQAHgHAAgNIAAgHQgGAGgHADQgIAEgJAAQgLAAgKgFQgKgFgGgJQgHgIgDgMQgEgLAAgOIAAgCQAAgOAEgMQADgMAHgIQAGgKAKgEQAKgFALABQALgBAHAEQAJAEAFAGIACgMIAeAAIAAB6QAAANgEAKQgFALgIAGQgIAIgLADQgLAEgNAAIgMgBgAgIg6QgGADgCAEQgEAFgCAHQgBAIAAAHIAAACQAAAJABAGQACAGAEAFQACAFAGADQAEACAGAAQAIAAAFgCQAGgDADgGIAAg1QgDgFgGgDQgFgDgIAAQgFAAgFADg',
      );
    this.shape.setTransform(62.3, 4.25);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAVBAIAAhQQAAgFgCgFQgBgDgDgDIgGgDIgJgBQgGAAgFADQgGADgDAGIAABYIgiAAIAAh+IAgAAIABAQQAHgJAJgEQAIgFALABQAJgBAIADQAHADAFAFQAGAGADAJQADAKAAANIAABPg',
      );
    this.shape_1.setTransform(48.975, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQBYIAAh+IAhAAIAAB+gAgHg2QgDgBgDgCIgEgGIgBgHQAAgIAFgFQAFgEAIgBIAIACIAGADQACADACADIABAHIgBAHIgEAGQgDACgDABQgEABgEAAQgDAAgEgBg',
      );
    this.shape_2.setTransform(39.125, -0.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgjBZIgDgBIgEAAIgDgBIAAgaIACAAIADAAIAIgBIAHgBIAEgFIADgGIAEgJIgth/IAlAAIAWBPIAYhPIAkAAIgzCRIgEALQgDAFgEAFQgFAFgGADQgHADgKAAIgFAAg',
      );
    this.shape_3.setTransform(29.925, 4.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgdA/QgIgDgGgFQgGgFgDgHQgDgHAAgIQAAgKADgIQAEgIAHgEQAIgGALgCQALgDANAAIAPAAIAAgHQAAgJgEgGQgFgFgIAAQgJAAgFAEQgFAEAAAIIghAAQAAgJADgHQAEgHAHgGQAHgFAKgEQAKgDALAAQALAAAKADQAJADAHAFQAHAGAEAIQADAJAAALIAAA0IABAKIABAIIABAGIACAFIAAACIgiAAQgCgEgBgHQgFAGgIAEQgHAEgLAAQgJAAgIgDgAgHAHQgFACgDACQgDADgCADQgBAEAAAEQAAAGAEAFQAEAEAIAAIAHgBIAHgDIAFgEIADgFIAAgVIgOAAQgFAAgFABg',
      );
    this.shape_4.setTransform(17.475, 1.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#FFFFFF').s().p('AgQBaIAAizIAhAAIAACzg');
    this.shape_5.setTransform(7.95, -0.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAfAAIABANQAGgIAJgDQAHgEAKAAQAMAAAJAFQAJAEAHAIQAFAJAEAMQADAMAAAOIAAADQAAAOgDALQgEALgFAJQgHAJgJAEQgJAGgMAAQgJgBgIgDQgIgEgFgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAFADAJAAQAGAAAEgDQAFgDADgFQADgEABgHQACgHAAgHIAAgDQAAgHgCgHQgCgHgCgFQgDgFgFgDQgFgDgFAAQgJAAgFAEg',
      );
    this.shape_6.setTransform(-1.75, 4.2);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAgAAIABANQAGgIAHgDQAIgEAJAAQANAAAJAFQAKAEAFAIQAHAJADAMQADAMAAAOIAAADQAAAOgDALQgDALgHAJQgFAJgKAEQgJAGgMAAQgJgBgIgDQgHgEgGgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAGADAIAAQAFAAAGgDQAEgDADgFQACgEACgHQABgHAAgHIAAgDQAAgHgBgHQgBgHgEgFQgDgFgEgDQgFgDgFAAQgIAAgGAEg',
      );
    this.shape_7.setTransform(-21.25, 4.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAHgIQAIgJALgFQALgFAMAAQAPAAAKAFQAKAEAIAIQAGAIAEAMQADALAAAOIAAAOIhPAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAHAAQAJAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgEABgEAEQgDADgBAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_8.setTransform(-34.6, 1.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgMgFgIgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAHAIAEAMQAEALAAAOIAAAOIhQAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAGAAQAKAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgFABgDAEQgCADgCAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_9.setTransform(-47.55, 1.875);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p('AAcBVIgrhEIgSAUIAAAwIgkAAIAAipIAkAAIAABNIAPgVIArg4IArAAIg9BLIA/Beg');
    this.shape_10.setTransform(-60.925, -0.325);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.nextBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.moreBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgEgLAAgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAIAIADAMQAEALAAAOIAAAOIhQAAQAAAGADAFQACAFAFAEQAEADAFACQAEACAGAAQAKAAAHgDQAJgEAFgHIARATQgDAEgFAEIgLAIIgNAFQgIACgJAAQgOAAgMgFgAgHgjQgEABgDAEQgEADgBAFIgDALIAuAAIAAgDIgBgJQgBgFgEgDQgCgDgEgCQgFgBgGAAQgEAAgEACg',
      );
    this.shape.setTransform(22.75, 1.875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AA5BAIAAhPQAAgHgBgEQgCgEgDgCQgCgDgEAAIgHgBQgIAAgGAEQgFAEgDAGIAAACIAAABIAABTIggAAIAAhPQAAgHgCgEQAAgDgDgDIgGgDIgJgBQgHAAgFADQgFADgDAGIAABYIgiAAIAAh+IAgAAIABAPQAGgIAKgEQAIgFAMABQAMgBAIAFQAIAEAFALQAGgJAJgGQAKgEANAAQAJgBAIADQAHADAGAFQAFAGADAKQADAIAAAOIAABPg',
      );
    this.shape_1.setTransform(5.75, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYA9QgMgFgHgJQgIgIgEgMQgEgMAAgOIAAgBQAAgOAEgMQAEgMAIgIQAHgJALgFQAMgFANAAQAOAAAMAFQALAFAIAJQAHAIAEAMQAEAMAAAOIAAABQAAAOgEAMQgEAMgHAIQgIAJgLAFQgLAFgPAAQgNAAgLgFgAgLgiQgFADgDAFQgDAFgCAHQgBAGAAAIIAAABQAAAIABAHQACAGADAGQADAEAFADQAFADAGAAQAHAAAFgDQAFgDADgEQADgGACgGQABgHAAgIIAAgBQAAgIgBgGQgCgHgDgFQgDgFgFgDQgFgDgHAAQgGAAgFADg',
      );
    this.shape_2.setTransform(-11.425, 1.875);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AAjBVIAAhJIhEAAIAABJIgkAAIAAipIAkAAIAABFIBEAAIAAhFIAjAAIAACpg');
    this.shape_3.setTransform(-26.7, -0.325);

    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.btnHover },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.moreBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.continueBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('Ag1BQIAAifIBqAAIAAAeIhBAAIAAAfIA9AAIAAAdIg9AAIAABFg');
    this.shape.setTransform(66.3, -0.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p('AgqBQIAAgcIAXAAIAAhnIgXAAIAAgcIBVAAIAAAcIgXAAIAABnIAXAAIAAAcg');
    this.shape_1.setTransform(53.975, -0.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgUBQIg3ifIAqAAIAiBrIAihrIApAAIg3Cfg');
    this.shape_2.setTransform(41.225, -0.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoAwQgTgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQAAAIADAGQAEAFAEAEQAFADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgSgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape_3.setTransform(20.85, 1.325);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AguAyQgJgLgBgWIAAhOIAmAAIAAA7IABAPQAAAGACAEQACAEADACQAEABAGAAQAEAAAFgBIAKgGIAAhUIAmAAIAAB3IgmAAIAAgNQgKAJgIADQgIAFgLAAQgRAAgLgMg',
      );
    this.shape_4.setTransform(7.2, 1.55);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgEABgGAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQALAMgBAWIAABOg',
      );
    this.shape_5.setTransform(-6.8, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_6.setTransform(-17.225, -0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgTBFQgKgJAAgWIAAg3IgOAAIAAgaIAOAAIAAgjIAkAAIAAAjIAlAAIAAAaIglAAIAAAqIABALQAAAEABAEQACAEAEACQAEACAHAAIAIgBIAHgCIADAAIAAAaIgNADIgRABQgWAAgLgKg',
      );
    this.shape_7.setTransform(-25.05, -0.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AATA+IAAg8IgBgOQgBgGgBgEQgCgEgEgCQgEgCgFAAIgJACQgEABgGAEIAABVIgmAAIAAh4IAmAAIAAAOQAJgIAJgFQAIgEALAAQASAAAKALQAKAMgBAWIAABOg',
      );
    this.shape_8.setTransform(-36.7, 1.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_9.setTransform(-50.625, 1.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsA+QgVgXAAgnQAAglAVgXQAVgWAjAAIARABIAPADIAMAFIAKAEIAAAmIgEAAIgHgFIgKgIQgGgEgGgCQgHgCgIAAQgIAAgIACQgFADgHAHQgGAGgEAKQgEALAAAOQAAAOAEALQAEAJAHAHQAGAGAGACQAIADAIAAQAHAAAIgDQAHgCAFgDIAJgHIAHgGIAEAAIAAAmIgKAEIgMAFIgOADIgSABQgjAAgVgVg',
      );
    this.shape_10.setTransform(-64.75, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.continueBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreen = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.stickersText = new cjs.Text(
      'Congratulations!',
      "bold 32px 'Roboto'",
      '#003399',
    );
    this.stickersText.name = 'stickersText';
    this.stickersText.textAlign = 'center';
    this.stickersText.lineHeight = 44;
    this.stickersText.lineWidth = 498;
    this.stickersText.parent = this;
    this.stickersText.setTransform(396.95, 319.5);

    this.beforeScoreText = new cjs.Text(
      'You scored',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.beforeScoreText.name = 'beforeScoreText';
    this.beforeScoreText.textAlign = 'center';
    this.beforeScoreText.lineHeight = 42;
    this.beforeScoreText.lineWidth = 451;
    this.beforeScoreText.parent = this;
    this.beforeScoreText.setTransform(401.5, 121.35);

    this.pointsText = new cjs.Text('0', "bold 60px 'Roboto'", '#003399');
    this.pointsText.name = 'pointsText';
    this.pointsText.textAlign = 'center';
    this.pointsText.lineHeight = 78;
    this.pointsText.lineWidth = 196;
    this.pointsText.parent = this;
    this.pointsText.setTransform(400.95, 144.8);

    this.afterScoreText = new cjs.Text(
      'points',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.afterScoreText.name = 'afterScoreText';
    this.afterScoreText.textAlign = 'center';
    this.afterScoreText.lineHeight = 42;
    this.afterScoreText.lineWidth = 488;
    this.afterScoreText.parent = this;
    this.afterScoreText.setTransform(401.95, 203.7);

    this.messageText = new cjs.Text(
      'Congratulations!',
      "bold 40px 'Roboto'",
      '#003399',
    );
    this.messageText.name = 'messageText';
    this.messageText.textAlign = 'center';
    this.messageText.lineHeight = 54;
    this.messageText.lineWidth = 498;
    this.messageText.parent = this;
    this.messageText.setTransform(396.95, 243.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.messageText },
            { t: this.afterScoreText },
            { t: this.pointsText },
            { t: this.beforeScoreText },
            { t: this.stickersText },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(424.95, 421);

    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(586.1, 421, 0.7647, 1);

    this.nextBtn = new lib.nextBtn();
    this.nextBtn.name = 'nextBtn';
    this.nextBtn.setTransform(242.05, 421);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.nextBtn },
            { t: this.moreBtn },
            { t: this.continueBtn },
          ],
        })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 275);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreen,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.TestWindow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { current: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // current
    this.row2col0 = new lib.numberPanel();
    this.row2col0.name = 'row2col0';
    this.row2col0.setTransform(90.25, 373.1, 1.8199, 1.7668, 0, 0, 0, 17.2, 13);

    this.row2col2 = new lib.numberPanel();
    this.row2col2.name = 'row2col2';
    this.row2col2.setTransform(466.1, 374.1, 1.8198, 1.7673, 0, 0, 0, 17.1, 13);

    this.row2col1 = new lib.numberPanel();
    this.row2col1.name = 'row2col1';
    this.row2col1.setTransform(
      278.15,
      373.1,
      1.8199,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col2 = new lib.numberPanel();
    this.row1col2.name = 'row1col2';
    this.row1col2.setTransform(466.1, 193.1, 1.8198, 1.7668, 0, 0, 0, 17.1, 13);

    this.row1col1 = new lib.numberPanel();
    this.row1col1.name = 'row1col1';
    this.row1col1.setTransform(
      278.15,
      193.1,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col0 = new lib.numberPanel();
    this.row1col0.name = 'row1col0';
    this.row1col0.setTransform(
      90.25,
      193.3,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row0col2 = new lib.numberPanel();
    this.row0col2.name = 'row0col2';
    this.row0col2.setTransform(466.1, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col1 = new lib.numberPanel();
    this.row0col1.name = 'row0col1';
    this.row0col1.setTransform(278.15, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col0 = new lib.numberPanel();
    this.row0col0.name = 'row0col0';
    this.row0col0.setTransform(90.25, 12.35, 1.82, 1.7668, 0, 0, 0, 17.2, 12.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.row0col0 },
            { t: this.row0col1 },
            { t: this.row0col2 },
            { t: this.row1col0 },
            { t: this.row1col1 },
            { t: this.row1col2 },
            { t: this.row2col1 },
            { t: this.row2col2 },
            { t: this.row2col0 },
          ],
        })
        .wait(1),
    );

    // initial
    this.bigSheet = new lib.BigBoard();
    this.bigSheet.name = 'bigSheet';
    this.bigSheet.setTransform(2196.4, 664.65, 1, 1, 0, 0, 0, 579.5, 482.7);

    this.timeline.addTween(cjs.Tween.get(this.bigSheet).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.TestWindow,
    new cjs.Rectangle(18, -59.9, 2747.2, 1267.1000000000001),
    null,
  );

  (lib.GameStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // stuff...
    this.mPiece = new lib.mPiece();
    this.mPiece.name = 'mPiece';
    this.mPiece.setTransform(145.1, -41.95, 1, 1, 0, 0, 0, 23.2, 25.9);

    this.roundMeter = new lib.verticalMeter();
    this.roundMeter.name = 'roundMeter';
    this.roundMeter.setTransform(660.95, 257, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAlQgHgJAAgQQAAgJACgEQACgHAFgFQAEgEAFgDQAGgCAGAAIAIABIAIADIAAgcIAVAAIAABaIgVAAIAAgHQgFAFgFACQgEACgGAAQgMABgHgKgAgIgBQgEADAAAKQAAAJAEAFQADAFAGAAIAGgCIAGgDIAAgfIgFgCIgEAAQgHABgFAFg',
      );
    this.shape.setTransform(663.375, 249.55);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AAMAiIAAghIgBgHIgBgGQAAAAgBgBQAAAAAAgBQgBAAAAAAQgBgBAAAAIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAGgDQAEgCAGAAQALAAAGAGQAGAHAAAMIAAAqg',
      );
    this.shape_1.setTransform(655.15, 250.625);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAbQgGgFAAgNIAAgqIAVAAIAAAhIAAAHQABADABADQAAAAABABQAAAAAAABQABAAAAAAQABABABAAIAFABIAFgBIAHgDIAAguIAVAAIAABBIgVAAIAAgHIgLAHQgDACgIAAQgLAAgFgHg',
      );
    this.shape_2.setTransform(646.55, 250.8);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAaQgJgKAAgQQAAgPAJgKQAKgJAQAAQARAAAKAJQAJAKAAAPQAAAQgJAKQgKAJgRAAQgQAAgKgJgAgEgSIgFADIgDAGIgBAJIABAJQABAEACADIAEADIAFABIAGgBQACAAACgDIAEgGIABgKIgBgIQgCgFgCgCIgEgDIgGgBIgEABg',
      );
    this.shape_3.setTransform(638.15, 250.7);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAVIgCAAIgEgBIgFAAIgIAAIgHACIAAArg',
      );
    this.shape_4.setTransform(631.475, 250.7);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgYAaQgKgJAAgRQAAgPAKgKQAKgJARAAQAPAAAJAIQAIAJAAAPIAAAGIgwAAQABAIAGAEQAFAEAKAAQAGAAAGgDIAKgFIACAAIAAARIgNAFQgHABgHAAQgTAAgLgJgAgIgSQgEAEgBAGIAbAAQgBgGgCgEQgDgCgHAAQgGAAgDACg',
      );
    this.shape_5.setTransform(717.5, 250.7);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AAhAiIAAghIgBgHIgBgGQAAAAAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAIgGgBIgFABIgHADIAAAuIgUAAIAAghIAAgHIgBgGIgDgDIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAGgEAFgCQAFgDAGAAQAGAAAEADQAFADADAGQAGgGAGgDQAGgDAGAAQALAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_6.setTransform(707.225, 250.625);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAABABAAIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_7.setTransform(696.625, 250.725);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAtIgLgCIAAgQIACAAIAKADIAJABIAJgBQAEgBACgCIACgFIABgHIAAgBQgEADgEABQgFACgFAAQgNAAgIgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAGgCQAFgCAGAAIAJABIAIADIABgDIAUAAIAAA6QAAAJgCAGQgDAHgFADQgFAEgGABQgHACgHAAIgOgBgAgIgZQgEAFAAAIQAAAKAEACQADAEAGAAIAGgBIAGgCIAAgdIgEgBIgFgBQgHAAgFAFg',
      );
    this.shape_8.setTransform(688.425, 251.875);

    this.gameMeter = new lib.verticalMeter();
    this.gameMeter.name = 'gameMeter';
    this.gameMeter.setTransform(718.95, 257, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.rulesclip = new lib.rules();
    this.rulesclip.name = 'rulesclip';
    this.rulesclip.setTransform(677.25, 183.95, 1, 1, 0, 0, 0, 65, 142.8);

    this.testWindow = new lib.TestWindow();
    this.testWindow.name = 'testWindow';
    this.testWindow.setTransform(160.35, 199.4, 1, 1, 0, 0, 0, 170.8, 130.1);

    this.startButton = new lib.start();
    this.startButton.name = 'startButton';
    this.startButton.setTransform(600.2, 619.45, 1, 1, 0, 0, 0, 39.2, 18.2);

    this.blocker = new lib.blocker();
    this.blocker.name = 'blocker';
    this.blocker.setTransform(217.5, 236.75, 3.0072, 3.7325, 0, 0, 0, 69, 57);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#7AA8F9')
      .s()
      .p('EgJhAp7QhBgBAAhAMAAAhRzQAAhBBBABITDAAQBBgBAABBMAAABRzQAABAhBABg');
    this.shape_9.setTransform(676.75, 280.1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_9 },
            { t: this.blocker },
            { t: this.startButton },
            { t: this.testWindow },
            { t: this.rulesclip },
            { t: this.gameMeter },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.roundMeter },
            { t: this.mPiece },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameStage,
    new cjs.Rectangle(7.6, -95.9, 2747.1, 1372.4),
    null,
  );

  (lib.comsuntexsymbolsScoreboard = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.progressPanel = new lib.ProgressPanel();
    this.progressPanel.name = 'progressPanel';
    this.progressPanel.setTransform(283.95, 20.7, 1, 1, 0, 0, 0, 274.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressPanel).wait(1));

    // buttons
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(778.45, 20);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(738.45, 20);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.musicBtn }, { t: this.muteBtn }] })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#000000').s().p('Eg+zADSIAAmjMB9nAAAIAAGjg');
    this.shape.setTransform(400, 21);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsScoreboard,
    new cjs.Rectangle(-2, 0, 804, 42),
    null,
  );

  (lib.PracticeMenu = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.text = new cjs.Text(
      'Select a practice round:',
      "bold 24px 'Roboto'",
      '#003399',
    );
    this.text.textAlign = 'center';
    this.text.lineHeight = 35;
    this.text.parent = this;
    this.text.setTransform(398.05, 244.75);

    this.round4Btn = new lib.roundBtn4();
    this.round4Btn.name = 'round4Btn';
    this.round4Btn.setTransform(550, 330.6, 1.1111, 1.1106);

    this.round3Btn = new lib.roundBtn3();
    this.round3Btn.name = 'round3Btn';
    this.round3Btn.setTransform(450, 330.6, 1.1111, 1.1106);

    this.round2Btn = new lib.roundBtn2();
    this.round2Btn.name = 'round2Btn';
    this.round2Btn.setTransform(350, 330.6, 1.1111, 1.1106);

    this.round1Btn = new lib.roundBtn1();
    this.round1Btn.name = 'round1Btn';
    this.round1Btn.setTransform(250, 330.6, 1.1111, 1.1106);

    this.text_1 = new cjs.Text(
      "You've finished earning stickers,\nbut you can still practice!",
      "bold 26px 'Roboto'",
      '#003399',
    );
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 37;
    this.text_1.parent = this;
    this.text_1.setTransform(399.05, 135.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.text_1 },
            { t: this.round1Btn },
            { t: this.round2Btn },
            { t: this.round3Btn },
            { t: this.round4Btn },
            { t: this.text },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(398.05, 425.4);

    this.timeline.addTween(cjs.Tween.get(this.moreBtn).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 285);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.PracticeMenu,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsGameFrame = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.GameFrame_veil();
    this.veil.name = 'veil';
    this.veil.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // changeRoundBtn
    this.changeRoundBtn = new lib.Scoreboard_changeRoundBtn();
    this.changeRoundBtn.name = 'changeRoundBtn';
    this.changeRoundBtn.setTransform(672.3, 578.8);

    this.timeline.addTween(cjs.Tween.get(this.changeRoundBtn).wait(1));

    // scoreboard
    this.scoreboard = new lib.comsuntexsymbolsScoreboard();
    this.scoreboard.name = 'scoreboard';
    this.scoreboard.setTransform(355.1, 573, 1, 1, 0, 0, 0, 355.1, 13);

    this.timeline.addTween(cjs.Tween.get(this.scoreboard).wait(1));

    // practiceMenu
    this.practiceMenu = new lib.PracticeMenu();
    this.practiceMenu.name = 'practiceMenu';
    this.practiceMenu.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.practiceMenu).wait(1));

    // endScreen
    this.endScreen = new lib.EndScreen();
    this.endScreen.name = 'endScreen';
    this.endScreen.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.endScreen).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsGameFrame,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  // stage content:
  (lib.VIFRulesMulDiv = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gameFrame
    this.gameFrame = new lib.comsuntexsymbolsGameFrame();
    this.gameFrame.name = 'gameFrame';
    this.gameFrame.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.gameFrame).wait(1));

    // gameStage
    this.gameStage = new lib.GameStage();
    this.gameStage.name = 'gameStage';
    this.gameStage.setTransform(396, 273.8, 1, 1, 0, 0, 0, 396, 273.8);

    this.timeline.addTween(cjs.Tween.get(this.gameStage).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(395, 204.1, 2359.7, 1072.4);
  // library properties:
  lib.properties = {
    id: 'F99A2D34C007BC4AB551A67EDC1614C2',
    width: 800,
    height: 600,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['F99A2D34C007BC4AB551A67EDC1614C2'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
